{
	"language_name": "English",

	"dialog.ok": "OK",
	"dialog.cancel": "Cancel",
	"dialog.confirm": "Confirm",
	"dialog.close": "Close",
	"dialog.yes": "Yes",
	"dialog.no": "No",
	"dialog.import": "Import",
	"dialog.save": "Save",
	"dialog.discard": "Discard",
	"dialog.continue": "Continue",
	"dialog.ignore": "Ignore",
	"dialog.ignore_all": "Ignore All",
	"dialog.dontshowagain": "Don't Show Again",
	"dialog.copy_to_clipboard": "Copy to clipboard",
	"dialog.open_url": "Open URL",
	"dialog.copied_to_clipboard": "Copied to clipboard",
	"dialog.advanced": "Advanced",
	"dialog.recommended_option": "recommended",

	"data.cube": "Cube",
	"data.locator": "Locator",
	"data.null_object": "Null Object",
	"data.mesh": "Mesh",
	"data.texture_mesh": "Texture Mesh",
	"data.generated_item_mesh": "Generated Item Model",
	"data.spline_mesh": "Spline",
	"data.billboard": "Billboard",
	"data.bounding_box": "Bounding Box",
	"data.group": "Group",
	"data.armature": "Armature",
	"data.armature_bone": "Armature Bone",
	"data.texture": "Texture",
	"data.texture_group": "Texture Group",
	"data.animation": "Animation",
	"data.layer": "Layer",
	"data.origin": "Pivot",
	"data.plugin": "Plugin",
	"data.preview": "Preview",
	"data.panel": "Panel",
	"data.toolbar": "Toolbar",
	"data.separator": "Separator",
	"data.separator.spacer": "Spacer",
	"data.separator.linebreak": "Line Break",
	"data.image": "Image",
	"data.format": "Format",
	"data.effect": "Effect",
	"data.color": "Color",
	"data.setting": "Setting",
	"data.settings_profile": "Profile",
	"data.reference_image": "Reference Image",
	"data.file_path": "File Path",

	"generic.delete": "Delete",
	"generic.remove": "Remove",
	"generic.rename": "Rename",
	"generic.import": "Import",
	"generic.export": "Export",
	"generic.share": "Share",
	"generic.download": "Download",
	"generic.search": "Search",
	"generic.help": "Help",
	"generic.name": "Name",
	"generic.default": "Default",
	"generic.all": "All",
	"generic.none": "None",
	"generic.unset": "Unset",
	"generic.enable": "Enable",
	"generic.disable": "Disable",
	"generic.redacted": "Redacted",
	"generic.reset": "Reset",
	"generic.restore": "Restore",
	"generic.reload": "Reload",
	"generic.select_all": "Select All",
	"generic.select_none": "Select None",
	"generic.delete_all": "Delete All",
	"generic.edit_externally": "Edit Externally",
	"generic.on": "On",
	"generic.off": "Off",
	"generic.left": "Left",
	"generic.right": "Right",
	"generic.navigate_forward": "Forward",
	"generic.navigate_back": "Back",
	"generic.error": "Error",
	"generic.confirm_delete": "Are you sure you want to delete this?",

	"dates.today": "Today",
	"dates.yesterday": "Yesterday",
	"dates.this_week": "This Week",
	"dates.weeks_ago": "%0 weeks ago",

	"dates.minute": "%0 Minute",
	"dates.minutes": "%0 Minutes",
	"dates.hour": "%0 Hour",
	"dates.hours": "%0 Hours",
	"dates.day": "%0 Day",
	"dates.days": "%0 Days",
	"dates.week": "%0 Week",
	"dates.weeks": "%0 Weeks",
	"dates.year": "%0 Year",
	"dates.years": "%0 Years",

	"units.pixels_per_meter": "%0 Pixels per Meter",

	"mode.edit": "Edit",
	"mode.paint": "Paint",
	"mode.display": "Display",
	"mode.animate": "Animate",
	"mode.pose": "Pose",

	"mode.start.new": "New",
	"mode.start.recent": "Recent",
	"mode.start.no_recents": "No recently opened models",
	"mode.start.recent.favorite": "Mark as Favorite",
	"mode.start.info": "Info",
	"mode.start.target": "Target",
	"mode.start.start": "Start",
	"mode.start.create_new": "Create New Model",
	"mode.start.format.informations": "Good to know:",
	"mode.start.format.resources": "Resources:",

	"mode.start.quick_setup": "Quick Setup",
	"mode.start.keymap_preference.desc": "If you are new to Blockbench and you are coming from another 3D program, you can select a keymap to make your transition easier. You can change the keymap or individual keybindings later in the settings.",
	"mode.start.keymap": "Keymap",
	"mode.start.quick_setup.more_themes": "More...",

	"projects.new_tab": "New Tab",
	"projects.start_screen": "Start Screen",
	"projects.close_tab": "Close Tab",

	"format.free": "Generic Model",
	"format.free.desc": "Model without restrictions. For game engines, rendering etc.",
	"format.free.info.3d_printing": "3D Printing",
	"format.free.info.meshes": "In this format, you can create low poly models using cubes and custom shaped meshes.",
	"format.free.info.limitation": "Models cannot be loaded into games that need specialized formats, such as Minecraft.",

	"format.skin": "Minecraft Skin",
	"format.skin.desc": "Edit player and entity skins",
	"format.skin.info.skin": "This format is designed to create Minecraft skins and entity textures.",
	"format.skin.info.model": "The model cannot be changed. In order to make changes to the model, first convert to a different format via **File** > **Convert Project**.",

	"format.java_block": "Java Block/Item",
	"format.java_block.desc": "Block or item model for Minecraft Java Edition.",
	"format.java_block.info.rotation": "Rotations are limited to one axis per element",
	"format.java_block.info.size": "The model is limited to a size of 3 by 3 by 3 blocks. Display settings can make item models larger though",
	"format.java_block.info.animation": "This format does not support animations in vanilla Minecraft. If you are creating a mod, you can use GeckoLib to animate models. If not, the only way to animate is to switch out the model using commands or animated textures.",
	
	"format.bedrock": "Bedrock Entity",
	"format.bedrock.desc": "Minecraft Bedrock Edition model for entities and item attachables",
	"format.bedrock.info.textures": "Each model can only have one texture",

	"format.bedrock_block": "Bedrock Block",
	"format.bedrock_block.desc": "Block model for Minecraft Bedrock Edition",
	"format.bedrock_old": "Bedrock Legacy Model",
	"format.bedrock_old.desc": "Pre-1.12 Minecraft Bedrock Edition entity model",
	"format.bedrock_block.info.size_limit": "Size total size of a block is limited to 30 pixels in all dimensions. The limit can be off-centered in all directions by 7 pixels from the block center.",
	"format.bedrock_block.info.textures": "Multiple textures can be applied to different cubes in Blockbench, but require additional setup in the behavior pack to work correctly in-game.",

	"format.modded_entity": "Modded Entity",
	"format.modded_entity.desc": "Entity model for Minecraft mods. Can be exported as .java class files.",
	"format.modded_entity.info.integer_size": "The size of individual cubes is limited to integers.",
	"format.modded_entity.info.format": "Models are written in Java code instead of dedicated data structures like all other Blockbench export formats.",

	"format.optifine_entity": "OptiFine Entity",
	"format.optifine_entity.desc": "Custom entity model for the OptiFine mod",
	"format.optifine_entity.info.optifine_required": "Users without OptiFine installed won't see the model.",
	"format.optifine_entity.info.pivots": "Bone pivots are locked, so it is a good idea to leave them untouched.",

	"format.optifine_part": "OptiFine Part",
	"format.optifine_part.desc": "JPM part for OptiFine entity models",

	"format.image": "Image",
	"format.image.desc": "Edit images in the 2D image editor",
	"format.image.new": "Create New Image",
	"format.image.info.summary": "The 2D Image editor lets you create and edit images and pixel art directly in Blockbench, without the need for an external image editor. Edit images, modify textures, or create your own pixel art!",

	"format_category.general": "General",
	"format_category.low_poly": "Low-Poly",
	"format_category.minecraft": "Minecraft",
	"format_category.other": "Other",
	"format_category.loaders": "Loaders",

	"keys.mouse": "Mouse Button %0",
	"keys.ctrl": "Ctrl",
	"keys.shift": "Shift",
	"keys.alt": "Alt",
	"keys.option": "Option",
	"keys.meta": "Cmd",
	"keys.delete": "Delete",
	"keys.space": "Space",
	"keys.leftclick": "Left Click",
	"keys.middleclick": "Middle Click",
	"keys.rightclick": "Right Click",
	"keys.tab": "Tab",
	"keys.backspace": "Backspace",
	"keys.enter": "Enter",
	"keys.escape": "Escape",
	"keys.function": "F%0",
	"keys.numpad": "Numpad %0",
	"keys.caps": "Capslock",
	"keys.menu": "Contextmenu",
	"keys.left": "Left",
	"keys.up": "Up",
	"keys.right": "Right",
	"keys.down": "Down",
	"keys.pageup": "Page Up",
	"keys.pagedown": "Page Down",
	"keys.plus": "Plus",
	"keys.comma": "Comma",
	"keys.point": "Point",
	"keys.minus": "Minus",
	"keys.cross": "Cross",
	"keys.end": "End",
	"keys.pos1": "Pos 1",
	"keys.printscreen": "Print Screen",
	"keys.pause": "Pause",
	"keys.mousewheel": "Mousewheel",
	"keys.slide_lmb_horizontal": "Left-click slide horizontal",
	"keys.slide_lmb_vertical": "Left-click slide vertical",
	"keys.slide_rmb_horizontal": "Right-click slide horizontal",
	"keys.slide_rmb_vertical": "Right-click slide vertical",

	"status_bar.saved":"Model is saved",
	"status_bar.recording":"Recording Timelapse",
	"status_bar.unsaved":"There are unsaved changes",
	"status_bar.vertex_distance":"Distance: %0",
	"status_bar.recording_gif":"Recording",
	"status_bar.processing_gif":"Processing",
	"status_bar.toggle_sidebar": "Toggle Sidebar",
	"status_bar.selection.faces": "%0 Faces",
	"status_bar.selection.edges": "%0 Edges",
	"status_bar.selection.vertices": "%0 Vertices",

	"modifier_actions.always": "Always Enabled",
	"modifier_actions.unless": "Unless %0",
	"modifier_actions.resize_both_sides": "Resize in both directions",
	"modifier_actions.resize_one_side": "Resize in one direction",
	"modifier_actions.draw_line": "Draw line",
	"modifier_actions.set_copy_source": "Set Copy Source",
	"modifier_actions.drag_without_snapping": "Drag without snapping",
	"modifier_actions.stretch_keyframes": "Stretch keyframes",
	"modifier_actions.resize_background": "Resize background",
	"modifier_actions.select_multiple": "Select multiple",
	"modifier_actions.select_range": "Select range",
	"modifier_actions.drag_to_duplicate": "Drag to duplicate",
	"modifier_actions.uniform_scaling": "Uniform Scaling",
	"modifier_actions.no_uniform_scaling": "Free Scaling",
	"modifier_actions.snap_direction": "Snap Direction",
	"modifier_actions.snap_to_center": "Snap to Center",
	"modifier_actions.snap_to_pixels": "Snap to Pixels",
	"modifier_actions.subtract": "Subtract",
	"modifier_actions.reduced_intensity": "Fine-Tune",
	"modifier_actions.select_bone": "Select Bone",
	"modifier_actions.spline_select_multiple_points": "Select multiple Points or Handles",
	"modifier_actions.move_panel_without_docking": "Move without docking",

	"message.canvas_limit_error.title": "Canvas Limit Error",
	"message.canvas_limit_error.message": "The action could not be performed correctly because the format limits the canvas to 48 units. Shift the pivot point to prevent this.",
	"message.rotation_limit.title": "Rotation Limits",
	"message.rotation_limit.message": "Rotations are limited by Minecraft to one axis. Rotating on a different axis will clear all rotations on the other axes. Convert the model to \"Generic Model\" if you are modeling for other purposes and need free rotations.",
	"message.file_not_found.title": "File Not Found",
	"message.file_not_found.message": "Blockbench could not find the requested file. Make sure it is saved locally and not in a cloud.",
	"message.recover_backup.title": "Recover Models",
	"message.recover_backup.message": "Blockbench was closed without saving. Do you want to recover the models?",
	"message.recover_backup.recover": "Recover",
	"message.recover_backup.unknown_project": "Unknown project",
	"message.recover_backup.discard_others": "Discard all others",
	"message.screenshot.title": "Screenshot",
	"message.screenshot.clipboard": "Clipboard",
	"message.screenshot.right_click": "Right click or long press the screenshot to copy",
	"message.screenshot_too_large.title": "Screenshot Resolution Issue",
	"message.screenshot_too_large.message": "The screenshot could not be rendered successfully. Please try again with a lower resolution or without supersampling.",
	"message.invalid_file.title": "Invalid File",
	"message.invalid_file.message": "Could not open json file: %0",
	"message.invalid_file.merge_conflict": "The file contains unresolved Git merge conflicts.",
	"message.invalid_model.title": "Invalid Model File",
	"message.invalid_model.message": "This file does not contain valid model data.",
	"message.invalid_format.title": "Invalid Format",
	"message.invalid_format.message": "This model was made in the format '%0', which is not available in your Blockbench installation. You most likely need a specific plugin to open it correctly.",
	"message.invalid_format.install_plugin": "Install plugin '%0'",
	"message.unsupported_file_extension.title": "File format not supported",
	"message.unsupported_file_extension.message": "Cannot open file %0, the format is not supported. You might need a plugin for this file type.",
	"message.unsupported_file_extension.open_in_default_program": "Open in default program",
	"message.cannot_re_import.title": "Model cannot be re-imported",
	"message.cannot_re_import.message": "The exported model format cannot be imported into Blockbench again. Please make sure to save your model as a project file.",
	"message.outdated_client.title": "Outdated client",
	"message.outdated_client.message": "Please update to the latest version of Blockbench to do this.",
	"message.newer_project_format_version.title": "Outdated client",
	"message.newer_project_format_version.message": "This file was saved in a newer version of Blockbench. Update to Blockbench %0 or newer to be able to open it correctly",
	"message.generated_item_model.title": "Generated Item Model",
	"message.generated_item_model.message": "This model has no elements of its own. Minecraft builds the item shape from the model's texture, so what you see here is only a preview of that shape. It cannot be edited, and is not exported.\n\nTo change how the item looks in game, edit the texture.",
	"message.generated_item_model.edit_texture": "Edit Texture",
	"message.generated_item_model.convert": "Convert to Editable Model",
	"message.convert_generated_item_model.title": "Convert to Editable Model",
	"message.convert_generated_item_model.message": "This builds real elements by extruding the texture, so you can change the item shape in 3D.\n\nIf you only want to change how the item looks, you do not need this. Edit the texture instead, and Minecraft will keep generating the shape from it.",
	"message.convert_generated_item_model.confirm": "Extrude Texture",
	"message.generated_item_model_conflict.title": "Generated Item Model",
	"message.generated_item_model_conflict.message": "Minecraft cannot use both a generated item model and elements. Now that this model has elements, the generated shape is ignored in game.",
	"message.generated_item_model_conflict.convert": "Convert the Generated Model to Cubes",
	"message.generated_item_model_conflict.convert.desc": "Extrude the texture into real elements, so nothing is lost",
	"message.generated_item_model_conflict.remove": "Remove the Generated Model",
	"message.generated_item_model_conflict.remove.desc": "Delete the preview and model the item from scratch",
	"message.generated_item_model_conflict.keep": "Keep It as a Reference",
	"message.generated_item_model_conflict.keep.desc": "Show it in Blockbench only, never exported",
	"message.child_model_only.title": "Empty Child Model",
	"message.child_model_only.message": "This file is a child of %0 and does not contain a model.",
	"message.child_model_only.resolve": "Resolve Parent Models",
	"message.child_model_only.resolve.desc": "Merge the whole parent chain into this model",
	"message.child_model_only.open": "Open Parent Model",
	"message.child_model_only.open.desc": "Open the parent in a new tab, keeping it separate from this model",
	"message.invalid_link": "Invalid or Expired Model Link",
	"message.invalid_link.message": "The shared model \"%0\" that you are trying to load is either invalid or has expired.",
	"message.delete_reference_image": "Are you sure you want to delete this reference image? This cannot be undone.",
	"message.add_reference_image.message": "Select where to load the reference image",
	"message.add_reference_image.globally": "Add for all projects",
	"message.plugin_dependencies.title": "Plugin Dependencies",
	"message.plugin_dependencies.message1": "The plugin requires these dependencies:",
	"message.plugin_dependencies.message1_update": "The plugin %0 has been updated and now requires these dependencies:",
	"message.plugin_dependencies.message2": "Do you want to install them to continue?",
	"message.plugin_dependencies.invalid": "Unfortunately the plugin cannot be installed, it has an invalid dependency:",
	"message.plugin_deprecated.message": "Are you sure you want to install this deprecated plugin?",
	"message.plugin_deprecated.install_anyway": "Install Anyway",
	"message.settings_require_restart.title": "Restart Required",
	"message.settings_require_restart.message": "Some settings will only apply after restarting the program.",
	"message.settings_require_restart.restart_now": "Restart Now",
	"message.settings_require_restart.restart_later": "Restart Later",

	"message.model_clipping.title": "Model Too Large",
	"message.model_clipping.message": "Your model contains %0 cubes that are larger than the blocks limit allowed by Minecraft. This model will not work in Minecraft.",
	"message.invalid_builtin_parent.title": "Invalid Built-in Parent",
	"message.invalid_builtin_parent.message": "The link to the invalid parent model '%0' was removed in order to export a valid model.",
	"message.cleared_blank_faces.title": "Blank Faces",
	"message.cleared_blank_faces.message": "Blockbench has found %0 cubes without any texture. Do you want to remove those elements?",
	"message.texture_refresh_conflict.title": "Conflicting Texture Versions",
	"message.texture_refresh_conflict.message": "The texture file might contain changes that conflict with Blockbench's version",
	"message.texture_refresh_conflict.keep_ours": "Keep Blockbench's version",
	"message.texture_refresh_conflict.keep_theirs": "Load file and discard all changes and layers in Blockbench",

	"message.loose_texture.title": "Texture Import",
	"message.loose_texture.message": "The imported texture is not contained in a resource pack. Minecraft can only load textures inside the textures folder of a loaded resource pack.",
	"message.loose_texture.change": "Change Path",
	"message.invalid_characters.title": "Invalid Path",
	"message.invalid_characters.message": "The path of the imported file contains invalid characters, uppercase letters, or white spaces. The supported characters are: %0",
	"message.update_res.title": "Texture Resolution",
	"message.update_res.message": "Would you like to update the project resolution to the resolution of this texture? Click 'Cancel' if your texture has a higher resolution than normal.",
	"message.update_res.update": "Update",
	"message.bedrock_overwrite_error.message": "Blockbench cannot combine this model with the old file",
	"message.bedrock_overwrite_error.backup_overwrite": "Create Backup and Overwrite",
	"message.bedrock_overwrite_error.overwrite": "Overwrite",
	"message.close_warning.message": "Do you want to save your model?",
	"message.close_warning.web": "Your current work will be lost. Are you sure you want to quit?",
	"message.default_textures.title": "Default Textures",
	"message.default_textures.message": "Select the \"textures\"-folder of the default resource pack",
	"message.default_textures.detail": "Extract the default resource pack from the Minecraft jar or google and download it. Then locate the \"textures\" folder and open it. Blockbench will remember that location and try to fetch textures from there if it can't find them in the current resource pack.",
	"message.default_textures.current": "Current path",
	"message.default_textures.select": "Select default \"textures\"-folder",
	"message.square_textures": "Textures have to be square",
	"message.unsaved_textures.title": "Unsaved Textures",
	"message.unsaved_textures.message": "Your model has unsaved textures. Make sure to save them and paste them into your resource pack in the correct folder.",
	"message.unsaved_texture.title": "Unsaved Texture",
	"message.unsaved_texture.message": "All unsaved changes to this texture will be lost. Do you want to proceed?",
	"message.save_all_textures.message": "Do you want to save each of the following textures?",
	"message.save_all_textures.skip": "Skip",
	"message.update_notification.title": "Could not Install Update",
	"message.update_notification.message": "A new Blockbench version is available. Please enable Automatic Updates in the settings in order to update!",
	"message.update_after_restart": "The update will be installed after the next restart",
	"message.installing_update.title": "Update Available",
	"message.installing_update.message": "A new version is ready to be installed. After closing the app, please allow for around %0 seconds before opening Blockbench again or turning off the computer, for the update to be installed.",
	"message.import_particle_texture.import": "Import Particle Texture",
	"message.import_particle_texture.message": "Would you like to import a texture file to be used for your particle?",

	"message.image_editor.title": "Select an image editor",
	"message.image_editor.file": "Select File...",
	"message.image_editor.exe": "Select image editor executable",
	"message.image_editor.not_found": "Could not find the selected image editor. Please select a different option.",
	"message.image_editor_missing.title": "Default Image Editor",
	"message.image_editor_missing.message": "Select the executable file of your image editor.",
	"message.image_editor_missing.detail": "Blockbench couldn't find an image editor on your computer. Select the executable file of your preferred image editor.",
	
	"message.delete_animation.title": "Delete Animation",
	"message.delete_animation.message": "The animation was removed from Blockbench. Do you also want to delete the animation from the file that is was saved in?",
	
	"message.save_codec_selector.title": "Save Model Format",
	"message.save_codec_selector.message": "Select a format to save the model in.",
	"message.save_codec_selector.project_file": "Blockbench Project (.bbmodel)",
	"message.save_codec_selector.both": "Both",

	"message.display_skin.title": "Minecraft Skin",
	"message.display_skin.message": "Select a skin file from your computer or enter a player name",
	"message.display_skin.upload": "Select File",
	"message.display_skin.username": "Username (Java)",
	"message.display_skin.reset": "Reset",
	"message.display_skin.invalid_name": "Cannot find Minecraft account with the name \"%0\".",

	"message.display_skin_model.title": "Skin Model",
	"message.display_skin_model.message": "Chose the model type of your skin",
	"message.display_skin_model.classic": "Classic",
	"message.display_skin_model.slim": "Slim",

	"message.invalid_plugin": "Invalid Plugin File, See Console",
	"message.load_plugin_app": "Do you want to allow this plugin to make changes to your PC? Only load plugins from authors you trust.",
	"message.load_plugin_web": "Do you want to load this plugin? Only load plugins from authors you trust.",
	"message.plugin_reload": "Reloaded %0 local plugins",
	"message.installed_plugin": "Successfully installed the plugin %0",
	"message.installed_plugin_fail": "Failed to installed the plugin %0",
	"message.classroom_mode.install_plugin": "Cannot install plugins in Classroom Mode",
	"message.preset_no_info": "Preset does not contain information for this slot",
	"message.restart_to_update": "Restart Blockbench to apply changes",
	"message.save_file": "Saved as %0",
	"message.untextured": "This surface does not have a texture",
	"message.sketchfab.name_or_token": "Please enter your Sketchfab token and a name",
	"message.sketchfab.success": "Uploaded model successfully",
	"message.sketchfab.error": "Failed to upload model to Sketchfab",
	"message.sketchfab.setup_guide": "Want to learn how to set up models in Sketchfab? Read %0",
	"message.removed_faces": "Removed %0 faces",
	"message.add_to_palette": "Added to palette",
	"message.size_modifiers": "Hold down Ctrl or Shift to transform in smaller increments.",
	"message.load_keymap": "Are you sure you want to load this keymap? This will overwrite your current keybindings.",
	"message.keymap_loaded": "Keymap loaded",
	"message.no_animation_to_import": "No animations to import",
	"message.copy_paste_tool_viewport": "This tool can only be used in the 2D editor",
	"message.no_valid_elements": "No valid elements selected...",
	"message.palette_locked": "The palette is locked",
	"message.knife_tool.confirm": "Press %0 or click here to apply Knife Tool",
	"message.knife_tool.skipped_face": "Cannot cut between different faces. Include the edges or vertices between them!",

	"message.wireframe.enabled": "Wireframe view enabled",
	"message.wireframe.disabled": "Wireframe view disabled",

	"message.timelapse_start": "Timelapse started",
	"message.timelapse_stop": "Timelapse stopped",

	"message.no_animation_selected": "You have to select an animation to do this",
	"message.group_required_to_animate": "You cannot animate this type of element. Create a group or armature to animate it.",
	"message.bone_material": "Change bone material",
	"message.no_bone_selected": "You have to select a bone to do this",
	"message.duplicate_groups.title": "Bone Name Duplicate",
	"message.duplicate_groups.message": "The name of this bone exists on multiple bones. This can cause problems.",
	"message.optimize_animation.keyframes_removed": "Removed %0 redundant keyframes",
	"message.optimize_animation.nothing_to_optimize": "Found nothing to optimize!",
	"message.duplicate_bone_copy_animation.title": "Copy Animation",
	"message.duplicate_bone_copy_animation.message": "The duplicated bone is animated in %0 animations. Do you want to copy the keyframes over to the new bone?",

	"message.small_face_dimensions.title": "Incompatible Face Dimensions",
	"message.small_face_dimensions.message": "The selection contains faces that are smaller than 1 unit in one direction. The Box UV mapping system considers any faces below that threshold as 0 pixels wide. The texture on those faces therefore may not work correctly.",
	"message.small_face_dimensions.face_uv": "The current format supports per-face UV maps which can handle small face dimensions. Right click the affected cubes and change \"UV Mode\" to \"Per-face UV\".",

	"message.auto_fix_mesh_edit.title": "Auto Fix",
	"message.auto_fix_mesh_edit.revert": "Revert Edit",
	"message.auto_fix_mesh_edit.overlapping_vertices": "Certain vertices have been moved into the same spot. How would you like to proceed?",
	"message.auto_fix_mesh_edit.concave_quads": "One or more quad faces are now concave, which can cause issues in UV-mapping and rendering. Blockbench can automatically fix it for you:",
	"message.auto_fix_mesh_edit.merge_vertices": "Merge Vertices",
	"message.auto_fix_mesh_edit.split_quads": "Split Quads",

	"message.merged_vertices": "Found and merged %0 vertices in %1 locations",

	"message.preview_scene_load_failed": "Failed to load preview scene. Check your internet connection.",

	"message.load_images.title": "Load Images",
	"message.load_images.edit_image": "Edit Image",
	"message.load_images.add_image": "Add Image",
	"message.load_images.add_layer": "Add as Layer",
	"message.load_images.category.add_to_project": "Add to project",
	"message.load_images.category.new_project": "New project",

	"message.import_palette.selection_only": "Selection only",
	"message.import_palette.replace_palette": "Replace old palette",
	"message.import_palette.threshold": "Merge Threshold",

	"message.load_palette.title": "Load Palette",
	"message.load_palette.message": "Are you sure you want to load this palette? This will replace your current color palette.",
	
	"message.load_plugin_failed.title": "Failed to load plugin",
	"message.load_plugin_failed.message": "Ensure that the base file name of the plugin matches the plugin ID `%0`, as specified in Plugin.register().",

	"message.invalid_session.title": "Invalid Session Token",
	"message.invalid_session.message": "The session you are trying to join has expired or the token provided is invalid.",

	"message.rename_elements.numbering": "You can use special characters to generate sequential numbers: % to get the index of the element within its group, $ to get the index within the selection.",

	"dialog.project.title": "Project",
	"dialog.project.name": "File Name",
	"dialog.project.parent": "Parent Model",
	"dialog.project.geoname": "Model Identifier",
	"dialog.project.credit": "Credit",
	"dialog.project.java_block_version": "Format Version",
	"dialog.project.modded_entity_version": "Export Version",
	"dialog.project.modded_entity_entity_class": "Entity Class",
	"dialog.project.modded_entity_flip_y": "Flip Y Axis",
	"dialog.project.ao": "Ambient Occlusion",
	"dialog.project.uv_mode": "UV Mode",
	"dialog.project.default_uv_mode": "Default UV Mode",
	"dialog.project.default_uv_mode.description": "Default UV Mode of the project. The UV mode can also be changed per cube.",
	"dialog.project.uv_mode.box_uv": "Box UV",
	"dialog.project.uv_mode.face_uv": "Per-face UV",
	"dialog.project.texture_size": "Texture Size",
	"dialog.project.uv_size": "UV Size",
	"dialog.project.shadow_size": "Shadow Size",

	"dialog.convert_project.title": "Convert Project",
	"dialog.convert_project.text1": "Convert the project into a different format.",
	"dialog.convert_project.text2": "Use conversion at your own risk. Formats have different features and restrictions, so converting will in some cases break parts of your project.",
	"dialog.convert_project.text3": "You cannot undo converting, that is why by default a copy will be created.",
	"dialog.convert_project.current_format": "Current Format",
	"dialog.convert_project.create_copy": "Create Copy",

	"dialog.select_texture.import_all": "Import All",

	"dialog.export_options.title": "Export Options",

	"dialog.unsaved_work.title": "Unsaved Work",
	"dialog.unsaved_work.text": "The following projects contain unsaved changes. Do you want to save your changes?",
	"dialog.unsaved_work.discard_all": "Discard All",
	"dialog.unsaved_work.save_all": "Save All",

	"dialog.collection.export_path": "Export Path",
	"dialog.collection.offset": "Offset",
	"dialog.collection.select_all": "Select All",
	"dialog.collection.select_none": "Select None",
	"dialog.collection.add_with_filter": "Add with Filter",
	"dialog.collection.remove": "Remove",

	"dialog.texture.title": "Texture",
	"dialog.texture.variable": "Variable",
	"dialog.texture.namespace": "Namespace",
	"dialog.texture.folder": "Folder",
	"dialog.texture.uv_size": "UV Size",
	"dialog.texture.fps": "FPS",
	"dialog.texture.fps.desc": "Frames per second of the texture flipbook animation",
	"dialog.texture.frame_time": "Frame Time",
	"dialog.texture.frame_time.desc": "Set for how long each frame will be visible, in ticks. Each tick is 1/20th of a second.",
	"dialog.texture.frame_interpolate": "Interpolate",
	"dialog.texture.frame_interpolate.desc": "Interpolate between animation frames by cross-fading to the next frame",
	"dialog.texture.frame_order_type": "Loop Mode",
	"dialog.texture.frame_order_type.loop": "Loop",
	"dialog.texture.frame_order_type.backwards": "Loop Backwards",
	"dialog.texture.frame_order_type.back_and_forth": "Back-and-Forth",
	"dialog.texture.frame_order_type.custom": "Custom Order",
	"dialog.texture.frame_order": "Frame Order",
	"dialog.texture.frame_order.desc": "Set a custom frame order by listing frame indices in a new order. Frame indices start at 0 with the first frame.",

	"dialog.resize_texture.mode": "Mode",
	"dialog.resize_texture.mode.crop": "Crop/Expand",
	"dialog.resize_texture.mode.scale": "Scale",
	"dialog.resize_texture.animation_frames": "Animation Frames",
	"dialog.resize_texture.fill": "Fill with",
	"dialog.resize_texture.fill.transparent": "Transparent",
	"dialog.resize_texture.fill.color": "Color",
	"dialog.resize_texture.fill.repeat": "Repeat",
	"dialog.resize_texture.offset": "Offset",

	"dialog.edit_uv_size.title": "Edit UV Size",
	"dialog.edit_uv_size.target": "Target",
	"dialog.edit_uv_size.adjust": "Adjust",
	"dialog.edit_uv_size.adjust.adjust_uv": "Counter UV",
	"dialog.edit_uv_size.adjust.adjust_scale": "Counter UV & Scale",
	"dialog.edit_uv_size.adjust.keep": "Keep UV",
	"dialog.edit_uv_size.target_size": "Target UV Size",
	"dialog.edit_uv_size.preset.original": "Original",
	"dialog.edit_uv_size.preset.match_texture": "Match Texture",
	"dialog.edit_uv_size.result": "Result",
	"dialog.edit_uv_size.result.textures": "Textures",

	"dialog.animated_texture_editor.code_reference": "Code Reference",
	"dialog.animated_texture_editor.code_reference.about": "This code to implement the texture animation was generated as a reference and does not necessarily work without modification. Check out the documentation to learn more.",
	"dialog.animated_texture_editor.code_reference.docs": "Documentation",
	"dialog.animated_texture_editor.reframe": "Reframe",
	"dialog.animated_texture_editor.stride": "Frame Size",
	"dialog.animated_texture_editor.frames": "Number of Frames",
	"dialog.animated_texture_editor.add_frame": "Add Frame",
	"dialog.animated_texture_editor.resize_frames": "Resize Frames...",
	"dialog.animated_texture_editor.apply": "Apply",

	"dialog.export_emission_map.title": "Export Emission Map",
	"dialog.export_emission_map.format": "Format",
	"dialog.export_emission_map.format.luminance": "Luminance",
	"dialog.export_emission_map.format.luminance_inverted": "Luminance Inverted",
	"dialog.export_emission_map.format.colors": "Colors",
	"dialog.export_emission_map.threshold": "Transparency Threshold",
	"dialog.export_emission_map.round_up": "Round Up to %0 x %1",
	"dialog.export_emission_map.flip_y": "Flip Y Axis",

	"dialog.generate_pbr_map.channel": "PBR Channel",
	"dialog.generate_pbr_map.channel.metalness": "Metalness",
	"dialog.generate_pbr_map.channel.emissive": "Emissive",
	"dialog.generate_pbr_map.channel.roughness": "Roughness",
	"dialog.generate_pbr_map.method": "Source",
	"dialog.generate_pbr_map.method.value": "Value",
	"dialog.generate_pbr_map.method.brightness": "Brightness",
	"dialog.generate_pbr_map.method.saturation": "Saturation",
	"dialog.generate_pbr_map.method.hue": "Hue",
	"dialog.generate_pbr_map.method.red": "Red",
	"dialog.generate_pbr_map.method.green": "Green",
	"dialog.generate_pbr_map.method.blue": "Blue",
	"dialog.generate_pbr_map.method.empty": "Empty",
	"dialog.generate_pbr_map.in_range": "Input Range",
	"dialog.generate_pbr_map.out_range": "Output Range",
	"dialog.generate_pbr_map.invert": "Invert",
	"dialog.generate_pbr_map.preset": "Preset",
	"dialog.generate_pbr_map.preset.apply_preset": "Apply Preset",
	"dialog.generate_pbr_map.update_values": "Update with current values",
	"dialog.generate_pbr_map.preset.new_preset": "New Preset...",

	"dialog.material_config.title": "Material Config",
	"dialog.material_config.color_value": "Color Value",
	"dialog.material_config.mer": "Metal-Emissive-Roughness",
	"dialog.material_config.mer_value": "MER Value",
	"dialog.material_config.subsurface": "Subsurface Scattering",
	"dialog.material_config.subsurface_enabled.desc": "Use the MER map alpha channel for subsurface scattering",
	"dialog.material_config.depth_type": "Depth Type",

	"dialog.edit_texture.preview": "Preview",

	"dialog.expand_texture_selection.radius": "Amount",
	"dialog.expand_texture_selection.corner": "Corner Shape",
	"dialog.expand_texture_selection.corner.round": "Round",
	"dialog.expand_texture_selection.corner.square": "Square",
	"dialog.expand_texture_selection.corner.manhattan": "Manhattan",

	"dialog.adjust_brightness_contrast.brightness": "Brightness",
	"dialog.adjust_brightness_contrast.contrast": "Contrast",
	"dialog.adjust_saturation_hue.saturation": "Saturation",
	"dialog.adjust_saturation_hue.hue": "Hue",
	"dialog.adjust_opacity.mode": "Mode",
	"dialog.adjust_opacity.mode.multiply": "Multiply",
	"dialog.adjust_opacity.mode.set": "Set",

	"dialog.extrude.title": "Extrude Image",
	"dialog.extrude.mode": "Scan Mode",
	"dialog.extrude.mode.areas": "Areas",
	"dialog.extrude.mode.lines": "Lines",
	"dialog.extrude.mode.columns": "Columns",
	"dialog.extrude.mode.pixels": "Pixels",
	"dialog.extrude.orientation": "Orientation",
	"dialog.extrude.orientation.upright": "Upright X",
	"dialog.extrude.orientation.upright_z": "Upright Z",
	"dialog.extrude.orientation.flat": "Flat",
	"dialog.extrude.depth": "Depth",
	"dialog.extrude.opacity": "Minimum Opacity",
	"dialog.extrude.scan": "Scan and Import",

	"dialog.display_preset.title": "Create Preset",
	"dialog.display_preset.message": "Select the slots you want to save",
	"dialog.display_preset.create": "Create",

	"dialog.select.title": "Select",
	"dialog.select.mode": "Mode",
	"dialog.select.mode.new": "New Selection",
	"dialog.select.mode.add": "Add to Selected",
	"dialog.select.mode.remove": "Remove from Selected",
	"dialog.select.mode.in_selection": "Select only from Selected",
	"dialog.select.group": "In Selected Group",
	"dialog.select.name": "Name Contains",
	"dialog.select.type": "Element Type",
	"dialog.select.random": "Random Chance (%)",
	"dialog.select.select": "Select",

	"dialog.find_replace.target": "Target",
	"dialog.find_replace.target.element_names": "Element Names",
	"dialog.find_replace.target.group_names": "Group Names",
	"dialog.find_replace.target.animation_names": "Animation Names",
	"dialog.find_replace.target.keyframe_values": "Keyframe Values",
	"dialog.find_replace.find": "Find",
	"dialog.find_replace.replace": "Replace",
	"dialog.find_replace.regex": "Regular Expression",

	"dialog.add_primitive.shape": "Shape",
	"dialog.add_primitive.shape.circle": "Circle",
	"dialog.add_primitive.shape.tube": "Tube",
	"dialog.add_primitive.shape.cone": "Cone",
	"dialog.add_primitive.shape.cylinder": "Cylinder",
	"dialog.add_primitive.shape.sphere": "Sphere",
	"dialog.add_primitive.shape.icosphere": "Icosphere",
	"dialog.add_primitive.shape.octahedron": "Octahedron",
	"dialog.add_primitive.shape.dodecahedron": "Dodecahedron",
	"dialog.add_primitive.shape.torus": "Torus",
	"dialog.add_primitive.shape.cube": "Cuboid",
	"dialog.add_primitive.shape.beveled_cuboid": "Beveled Cuboid",
	"dialog.add_primitive.shape.pyramid": "Pyramid",
	"dialog.add_primitive.shape.plane": "Plane",
	"dialog.add_primitive.diameter": "Diameter",
	"dialog.add_primitive.detail": "Detail",
	"dialog.add_primitive.align_edges": "Align Edges",
	"dialog.add_primitive.height": "Height",
	"dialog.add_primitive.sides": "Sides",
	"dialog.add_primitive.minor_diameter": "Thickness",
	"dialog.add_primitive.minor_sides": "Minor Sides",
	"dialog.add_primitive.edge_size": "Edge Size",

	"dialog.add_spline.shape": "Shape",
	"dialog.add_spline.shape.segment": "Segment",
	"dialog.add_spline.shape.square": "Rectangle",
	"dialog.add_spline.shape.circle": "Circle",
	"dialog.add_spline.diameter": "Diameter",
	"dialog.add_spline.sides_tubular": "Tube Segments",
	"dialog.add_spline.sides_radial": "Ring Segments",
	"dialog.add_spline.radius": "Tube Radius",
	"dialog.add_spline.length": "Length",
	"dialog.add_spline.width": "Width",

	"dialog.scale.title": "Scale Model",
	"dialog.scale.axis": "Axis",
	"dialog.scale.element_pivot": "Element Pivot",
	"dialog.scale.selection_center": "Selection Center",
	"dialog.scale.clipping": "Model clipping: Your model is too large for the canvas",
	"dialog.scale.confirm": "Scale",
	"dialog.scale.select_overflow": "Select Overflow",
	"dialog.scale.box_uv_warning": "Scaling cubes that use Box UV may break the UV mapping. Instead, try to scale your model during implementation, or switch to Per-face UV Mode in File > Project or per cube.",

	"dialog.proportional_editing.range": "Range",
	"dialog.proportional_editing.falloff": "Falloff",
	"dialog.proportional_editing.falloff.linear": "Linear",
	"dialog.proportional_editing.falloff.hermite_spline": "Smooth",
	"dialog.proportional_editing.falloff.constant": "Constant",
	"dialog.proportional_editing.selection": "Selection",
	"dialog.proportional_editing.selection.linear": "Linear Distance",
	"dialog.proportional_editing.selection.connections": "Connections",

	"dialog.set_vertex_weights.weight": "Weight",
	"dialog.set_vertex_weights.overwrite": "Overwrite other bones",

	"dialog.material_instances.title": "Material Instances",

	"dialog.bedrock_bounding_box.type": "Type",
	"dialog.bedrock_bounding_box.type.collision_box": "Collision",
	"dialog.bedrock_bounding_box.type.selection_box": "Selection Box",
	"dialog.bedrock_bounding_box.type.hitbox": "Hitbox",
	"dialog.bedrock_bounding_box.hitbox_note": "Please note that entity hitboxes only work up to a certain size and may not adapt to the rotation of the entity in-game.",
	"dialog.bedrock_bounding_box.collision_note": "Please note that entity collision boxes only support one centered shape with a square top profile.",
	"dialog.bedrock_bounding_box.no_bounding_boxes": "No bounding boxes exist in this project",

	"dialog.plugins.title": "Plugins",
	"dialog.plugins.installed": "Installed",
	"dialog.plugins.available": "Available",
	"dialog.plugins.install": "Install",
	"dialog.plugins.uninstall": "Uninstall",
	"dialog.plugins.reload": "Reload",
	"dialog.plugins.update": "Update",
	"dialog.plugins.update_available": "Update Available",
	"dialog.plugins.none_installed": "No plugins installed",
	"dialog.plugins.none_available": "No plugins available",
	"dialog.plugins.offline": "No internet connection",
	"dialog.plugins.outdated_client": "Requires a newer version of Blockbench",
	"dialog.plugins.outdated_plugin": "Plugin is outdated and does not work with this version of Blockbench",
	"dialog.plugins.web_only": "Only for the web app",
	"dialog.plugins.app_only": "Only for the desktop app",
	"dialog.plugins.author": "by %0",
	"dialog.plugins.is_installed": "Installed",
	"dialog.plugins.is_disabled": "Disabled",
	"dialog.plugins.disable": "Disable",
	"dialog.plugins.enable": "Enable",
	"dialog.plugins.revoke_permissions": "Revoke Permissions",
	"dialog.plugins.dependencies": "Depends on:",

	"dialog.load_plugins_from_query.title": "Load Plugins",
	"dialog.load_plugins_from_query.text": "You used a link that requires plugins to be installed. Would you like to install them?",

	"dialog.install_plugins_from_list.ids": "Plugin IDs",
	"dialog.install_plugins_from_list.info": "Install several plugins from a list of IDs. Before installing, please ensure that you actually need all plugins. Keeping inactive plugins can increase the risk of bugs and incompatibilities with future updates.",
	"dialog.copy_installed_plugins.details": "Include Details",

	"dialog.toolbar_edit.title": "Customize Toolbar",
	"dialog.toolbar_edit.hidden": "Hidden",
	"dialog.toolbar_edit.hidden_tools": "Some tools might be hidden because they are not available in the current mode, format, or situation.",

	"dialog.select_model.title": "Select Model",
	"dialog.select_model.bones": "Bones",
	"dialog.select_model.cubes": "Cubes",
	
	"dialog.animation_import.title": "Select Animations to Import",
	"dialog.animation_export.title": "Select Animations to Export",

	"dialog.change_animation_speed.speed": "Speed",
	"dialog.change_animation_speed.adjust_snapping": "Adjust Snapping",
	"dialog.optimize_animation.selection": "Selection",
	"dialog.optimize_animation.selection.selected_keyframes": "Selected Keyframes",
	"dialog.optimize_animation.selection.selected_animation": "Selected Animation",
	"dialog.optimize_animation.selection.all_animations": "All Animations",
	"dialog.optimize_animation.thresholds": "Threshold values",
	"dialog.merge_animation.merge_target": "Merge into",

	"dialog.blend_transition_edit.extended": "Extended Graph",
	"dialog.blend_transition_edit.ease_in_out": "Ease-in-out (%0)",
	"dialog.blend_transition_edit.generate": "Generate...",
	"dialog.blend_transition_edit.generate.learn_more": "More info and preview",
	"dialog.blend_transition_edit.generate.curve": "Easing Type",
	"dialog.blend_transition_edit.generate.steps": "Keyframes",

	"dialog.expression_editor.pretty_print": "Pretty Print",
	"dialog.expression_editor.minify": "Minify",
	"dialog.expression_editor.find_replace": "Find/Replace",

	"dialog.create_variable_placeholder.variable": "Variable",
	"dialog.create_variable_placeholder.type": "Type",
	"dialog.create_variable_placeholder.type.value": "Value",
	"dialog.create_variable_placeholder.type.slider": "Slider",
	"dialog.create_variable_placeholder.type.toggle": "Toggle",
	"dialog.create_variable_placeholder.type.impulse": "Impulse",
	"dialog.create_variable_placeholder.value": "Value",
	"dialog.create_variable_placeholder.duration": "Duration",
	"dialog.create_variable_placeholder.step": "Step",
	"dialog.create_variable_placeholder.range": "Range",
	"dialog.create_variable_placeholder.output": "Output",
	"dialog.view_built_in_variables.function": "Parameters required",

	"dialog.create_texture.folder": "Folder",
	"dialog.create_texture.type": "Type",
	"dialog.create_texture.type.blank": "Blank",
	"dialog.create_texture.type.template": "Texture Template",
	"dialog.create_texture.type.color_map": "Solid Color Template",
	"dialog.create_texture.rearrange_uv": "Rearrange UV",
	"dialog.create_texture.rearrange_uv.desc": "Create a new UV arrangement to give every face its own spot on the texture",
	"dialog.create_texture.power": "Power-of-2 Size",
	"dialog.create_texture.power.desc": "Lock the automatic texture size to a power-of-2, such as 64 or 128. This is required by some renderers",
	"dialog.create_texture.double_use": "Keep Multi Texture Occupancy",
	"dialog.create_texture.double_use.desc": "If two elements already have the same UV space assigned, keep it that way in the new map",
	"dialog.create_texture.padding": "Padding",
	"dialog.create_texture.padding.desc": "Add a small padding between the individual parts of the template",
	"dialog.create_texture.combine_polys": "Combine Islands",
	"dialog.create_texture.combine_polys.desc": "Combine faces into connected UV islands",
	"dialog.create_texture.max_edge_angle": "Edge Angle Threshold",
	"dialog.create_texture.max_edge_angle.desc": "The maximum angle between two faces at which they will still be combined",
	"dialog.create_texture.max_island_angle": "Island Angle Threshold",
	"dialog.create_texture.max_island_angle.desc": "The maximum angle that can be combined into the same UV island",
	"dialog.create_texture.resolution": "Resolution",
	"dialog.create_texture.resolution.desc": "The height and width of the texture",
	"dialog.create_texture.pixel_density": "Pixel Density",
	"dialog.create_texture.pixel_density.desc": "The pixel density of the texture, in pixels per meter. The size of the texture map may differ depending on the amount and size of elements.",
	"dialog.create_texture.disable_mirror_uv": "Disable UV Mirroring",
	"dialog.create_texture.disable_mirror_uv.desc": "Disable the UV Mirror option in Mirror Modeling to preserve separate UVs for each side of the model",

	"dialog.mirror_painting_texture_center.middle": "Middle",
	"dialog.mirror_painting_texture_center.custom": "Custom",

	"dialog.create_gif.title": "Record GIF",
	"dialog.create_gif.format": "Format",
	"dialog.create_gif.format.gif": "GIF",
	"dialog.create_gif.format.png_sequence": "PNG Sequence",
	"dialog.create_gif.length_mode": "Length Mode",
	"dialog.create_gif.length_mode.seconds": "Seconds",
	"dialog.create_gif.length_mode.frames": "Frames",
	"dialog.create_gif.length_mode.animation": "Animation Length",
	"dialog.create_gif.length_mode.turntable": "Turntable Rotation",
	"dialog.create_gif.length": "Length",
	"dialog.create_gif.fps": "FPS",
	"dialog.create_gif.pixelate": "Pixelate",
	"dialog.create_gif.color": "Background Color",
	"dialog.create_gif.bg_image": "Background Image",
	"dialog.create_gif.show_gizmos": "Record Gizmos & Grid",
	"dialog.create_gif.turn": "Turntable Speed",
	"dialog.create_gif.turn.desc": "Rotate the model while recording. Use negative values to turn the model clockwise. A value of 60 corresponds to one rotation every second.",
	"dialog.create_gif.turn.sync_to_anim_length": "Sync to animation length",
	"dialog.create_gif.play": "Play Animation",

	"dialog.advanced_screenshot.angle_preset": "Angle Preset",
	"dialog.advanced_screenshot.resolution": "Resolution",
	"dialog.advanced_screenshot.zoom_to_fit": "Zoom To Fit",
	"dialog.advanced_screenshot.zoom": "Zoom / Focal Length",
	"dialog.advanced_screenshot.anti_aliasing": "Anti-aliasing",
	"dialog.advanced_screenshot.anti_aliasing.off": "Off",
	"dialog.advanced_screenshot.anti_aliasing.msaa": "Multisampling",
	"dialog.advanced_screenshot.anti_aliasing.ssaa": "Supersampling",
	"dialog.advanced_screenshot.show_gizmos": "Show Edit Gizmos",
	"dialog.advanced_screenshot.shading": "Shading",
	"dialog.advanced_screenshot.export": "Export",

	"dialog.timelapse.interval": "Interval (Seconds)",
	"dialog.timelapse.source": "Source",
	"dialog.timelapse.source.interface": "Interface",
	"dialog.timelapse.source.locked": "Locked Angle",
	"dialog.timelapse.destination": "Destination Folder",

	"dialog.save_angle.projection": "Projection",
	"dialog.save_angle.projection.perspective": "Perspective",
	"dialog.save_angle.projection.orthographic": "Orthographic",
	"dialog.save_angle.position": "Camera Position",
	"dialog.save_angle.rotation_mode": "Rotation Mode",
	"dialog.save_angle.target": "Focal Point",
	"dialog.save_angle.rotation": "Rotation",
	"dialog.save_angle.zoom": "Zoom",
	"dialog.save_angle.fov": "FOV",

	"dialog.preview_options.title": "Preview Options",
	"dialog.preview_options.background": "Background",
	"dialog.preview_options.background.checkerboard": "Checkerboard",
	"dialog.preview_options.background.solid": "Solid",
	"dialog.preview_options.background.custom_color": "Custom Color",
	"dialog.preview_options.show_gizmos": "Show Gizmos",
	"dialog.preview_options.show_element_markers": "Show Element Markers",
	"dialog.preview_options.show_element_markers.desc": "Display markers to indicate the position for elements such as bones, null objects, and locators",

	"dialog.input.title": "Input",

	"dialog.view_backups.open_folder": "Open Folder",

	"dialog.import_obj.obj": "OBJ File",
	"dialog.import_obj.mtl": "MTL File",
	"dialog.import_obj.scale": "Scale",

	"dialog.sketchfab_uploader.title": "Upload Sketchfab Model",
	"dialog.sketchfab_uploader.token": "API Token",
	"dialog.sketchfab_uploader.about_token": "The token is used to connect Blockbench to your Sketchfab account. You can find it on %0",
	"dialog.sketchfab_uploader.name": "Model Name",
	"dialog.sketchfab_uploader.description": "Description",
	"dialog.sketchfab_uploader.animations": "Animations",
	"dialog.sketchfab_uploader.tags": "Tags",
	"dialog.sketchfab_uploader.suggested_tags": "Suggested Tags",
	"dialog.sketchfab_uploader.category": "Category",
	"dialog.sketchfab_uploader.category2": "Category 2",
	"dialog.sketchfab_uploader.draft": "Draft",
	"dialog.sketchfab_uploader.private": "Private (Pro)",
	"dialog.sketchfab_uploader.password": "Password (Pro)",

	"dialog.share_model.title": "Share Model",
	"dialog.share_model.expire_time": "Expire Time",
	"dialog.share_model.reference_images": "Include Reference Images",
	"dialog.share_model.thumbnail": "Thumbnail",
	"dialog.share_model.failed": "Failed to upload model",
	"dialog.share_model.too_large": "Failed to upload: Model is too large",
	"dialog.share_model.too_large_references": "Failed to upload: Model is too large. Try without reference images.",

	"dialog.model_stats.title": "Model Stats",
	"dialog.model_stats.cubes": "Cubes",
	"dialog.model_stats.locators": "Locators",
	"dialog.model_stats.meshes": "Meshes",
	"dialog.model_stats.groups": "Groups",
	"dialog.model_stats.vertices": "Vertices",
	"dialog.model_stats.faces": "Faces",

	"dialog.skin.title": "Create Minecraft Skin",
	"dialog.skin.model": "Model",
	"dialog.skin.variant": "Variant",
	"dialog.skin.high_res_texture": "Please note that skins with the selected resolution will not work as regular Minecraft skins. Select a lower resolution.",
	"dialog.skin.texture_source": "Texture Source",
	"dialog.skin.texture_source.template": "Generate Template",
	"dialog.skin.texture_source.load_texture": "Load from Minecraft",
	"dialog.skin.texture_file": "Texture File",
	"dialog.skin.pose": "Pose",
	"dialog.skin.layer_template": "Layer Texture",

	"dialog.convert_skin.adjust_texture": "Adjust Texture",

	"dialog.flip_animation.info": "Opposite bones are identified by the keywords 'left' and 'right' within their name.",
	"dialog.flip_animation.phase_offset": "Phase Offset",
	"dialog.flip_animation.phase_offset.off": "Off",
	"dialog.flip_animation.phase_offset.custom": "Custom",
	"dialog.flip_animation.clear_opposite": "Overwrite opposite",
	"dialog.flip_animation.show_in_timeline": "Show modified bones in timeline",

	"dialog.predicate_overrides.model": "Model",
	"dialog.predicate_overrides.predicates": "Predicates",
	"dialog.predicate_overrides.variants": "Variants",
	"dialog.predicate_overrides.start_value": "Start",
	"dialog.predicate_overrides.add_override": "Add Override",
	"dialog.predicate_overrides.add_predicate": "Add Predicate",
	"dialog.predicate_overrides.generate_overrides": "Generate Overrides",
	"dialog.predicate_overrides.confirm_delete": "Are you sure you want to delete all overrides?",

	"dialog.predicate_overrides.predicate.angle": "Compass Angle",
	"dialog.predicate_overrides.predicate.blocking": "Is Blocking",
	"dialog.predicate_overrides.predicate.broken": "Is Broken",
	"dialog.predicate_overrides.predicate.cast": "Is Cast",
	"dialog.predicate_overrides.predicate.cooldown": "Cooldown",
	"dialog.predicate_overrides.predicate.damage": "Damage",
	"dialog.predicate_overrides.predicate.damaged": "Is Damaged",
	"dialog.predicate_overrides.predicate.lefthanded": "Is Left-Handed",
	"dialog.predicate_overrides.predicate.pull": "Pull Amount",
	"dialog.predicate_overrides.predicate.pulling": "Is Pulling",
	"dialog.predicate_overrides.predicate.charged": "Is Charged",
	"dialog.predicate_overrides.predicate.firework": "Has Firework",
	"dialog.predicate_overrides.predicate.throwing": "Ready to Throw",
	"dialog.predicate_overrides.predicate.time": "Time of Day",
	"dialog.predicate_overrides.predicate.custom_model_data": "Custom Model Data",
	"dialog.predicate_overrides.predicate.level": "Light Level",
	"dialog.predicate_overrides.predicate.filled": "Bundle Fill Level",
	"dialog.predicate_overrides.predicate.tooting": "Tooting",

	"dialog.export_private_settings.title": "Private Settings",
	"dialog.export_private_settings.message": "Your file contains the following private informations: **%0**. Leave these values out if you plan to share the file with someone else.",
	"dialog.export_private_settings.keep": "Keep",
	"dialog.export_private_settings.omit": "Leave Out",
	
	"dialog.settings.settings": "Settings",
	"dialog.settings.keybinds": "Keybindings",
	"dialog.settings.theme": "Theme",
	"dialog.settings.about": "About",
	"dialog.settings.search_results": "Search Results",
	"dialog.settings.reset_to_default": "Reset to Default",
	"dialog.settings.create_profile": "Create Profile...",
	"dialog.settings.clear_profile_value": "Clear profile value",

	"keybindings.reset": "Reset",
	"keybindings.clear": "Unset",
	"keybindings.recording": "Recording Keybinding",
	"keybindings.press": "Press a key or key combination or click anywhere on the screen to record your keybinding.",
	"keybindings.variation_conflict": "Variation conflicts with the main keybinding",

	"keybindings.item.num_slider.increase": "Increase",
	"keybindings.item.num_slider.decrease": "Decrease",

	"layout.select": "Select",
	"layout.options": "Options",
	"layout.color": "Color Scheme",
	"layout.css": "Custom CSS",
	"layout.thumbnail": "Custom Thumbnail CSS",
	"layout.section.customize": "Customize",
	"layout.theme.configure": "Configure",
	"layout.documentation": "Documentation",
	"layout.restore_backup": "Your customized theme \"%0\" was overwritten. Click here to restore it.",
	"layout.color.back": "Back",
	"layout.color.back.desc": "Backgrounds and input fields",
	"layout.color.dark": "Dark",
	"layout.color.dark.desc": "Canvas background",
	"layout.color.ui": "UI",
	"layout.color.ui.desc": "Main interface color",
	"layout.color.bright_ui": "Bright UI",
	"layout.color.bright_ui.desc": "Context menus and tooltips",
	"layout.color.button": "Button",
	"layout.color.button.desc": "Buttons and switches",
	"layout.color.selected": "Selected",
	"layout.color.selected.desc": "Selected tabs and objects",
	"layout.color.elevated": "Elevated",
	"layout.color.elevated.desc": "Elevated UI elements, usually separated by drop shadow",
	"layout.color.border": "Border",
	"layout.color.border.desc": "Border of buttons and inputs",
	"layout.color.accent": "Accent",
	"layout.color.accent.desc": "Slider thumb and other details",
	"layout.color.frame": "Window Frame",
	"layout.color.frame.desc": "Border and title bar of the window",
	"layout.color.grid": "Grid",
	"layout.color.grid.desc": "3D preview grid",
	"layout.color.wireframe": "Wireframe",
	"layout.color.wireframe.desc": "Wireframe view lines",
	"layout.color.text": "Text",
	"layout.color.text.desc": "Normal text",
	"layout.color.light": "Light",
	"layout.color.light.desc": "Highlighted text",
	"layout.color.accent_text": "Accent Text",
	"layout.color.accent_text.desc": "Text on accent backgrounds",
	"layout.color.bright_ui_text": "Bright UI Text",
	"layout.color.bright_ui_text.desc": "Text on bright backgrounds",
	"layout.color.subtle_text": "Subtle Text",
	"layout.color.subtle_text.desc": "Secondary text color with less contrast",
	"layout.color.checkerboard": "Checkerboard",
	"layout.color.checkerboard.desc": "Background of canvas and UV editor",
	"layout.name": "Name",
	"layout.author": "Author",
	"layout.version": "Version",
	"layout.font.main": "Main Font",
	"layout.font.headline": "Headline Font",
	"layout.font.code": "Code Font",
	"layout.borders": "Borders",
	"layout.file.watch_changes": "Watch Changes and Reload",

	"about.version": "Version:",
	"about.version.up_to_date": "Up to date",
	"about.version.update_available": "Version %0 is available",

	"settings_profile.confirm_delete": "Are you sure you want to delete this settings profile?",
	"settings_profile.condition": "Condition",
	"settings_profile.condition.type.selectable": "Manually Selectable",
	"settings_profile.condition.type.file_path.desc": "Use Regular Expression syntax to match the file path of the current project. Use forward slashes for directories",

	"settings.category.general": "General",
	"settings.category.interface": "Interface",
	"settings.category.preview": "Preview",
	"settings.category.controls": "Controls",
	"settings.category.grid": "Grid",
	"settings.category.edit": "Edit",
	"settings.category.snapping": "Snapping",
	"settings.category.paint": "Paint",
	"settings.category.defaults": "Defaults",
	"settings.category.dialogs": "Dialogs",
	"settings.category.export": "Export",
	"settings.category.application": "Application",

	"settings.language": "Language",
	"settings.language.desc": "Interface language",
	"settings.username": "Username",
	"settings.username.desc": "Username for edit sessions",
	"settings.streamer_mode": "Streamer Mode",
	"settings.streamer_mode.desc": "Hides sensitive information like recent models",
	"settings.classroom_mode": "Classroom Mode",
	"settings.classroom_mode.desc": "Restricts functionality such as installing plugins and removes links to social media",
	"settings.cdn_mirror": "Use CDN Mirror",
	"settings.cdn_mirror.desc": "Use the mirror CDN to download plugins. The mirror receives updates faster and works in some regions where the default does not work.",
	"settings.recovery_save_interval": "Recovery Point Save Interval",
	"settings.recovery_save_interval.desc": "Blockbench regularly saves the open project in the background to recover in case of a computer crash. Set the interval in seconds. Set to 0 to disable saving.",

	"settings.interface_scale": "Interface Scale",
	"settings.interface_scale.desc": "Scale of the entire Blockbench interface",
	"settings.interface_mode": "UI Mode",
	"settings.interface_mode.desc": "Interface mode",
	"settings.interface_mode.auto": "Automatic",
	"settings.interface_mode.desktop": "Desktop",
	"settings.interface_mode.mobile": "Mobile",
	"settings.hide_tab_bar": "Auto-hide Tab Bar",
	"settings.hide_tab_bar.desc": "Hide the tab bar when only one tab is open",
	"settings.mobile_panel_side": "Mobile Panel Side",
	"settings.mobile_panel_side.desc": "Select which side of the screen panels are displayed on when using Blockbench on in landscape orientation",
	"settings.status_bar_modifier_keys": "Suggest Modifier Keys in Status Bar",
	"settings.status_bar_modifier_keys.desc": "Display context aware suggested modifier keys in the status bar",
	"settings.status_bar_transform_sliders": "Transform Sliders in Status Bar",
	"settings.status_bar_transform_sliders.desc": "Display the transform sliders toolbar of the selected tool in the status bar instead of using the Transform panel",
	"settings.always_show_splash_art": "Always Show Splash Art",
	"settings.always_show_splash_art.desc": "Always display the splash art on the start screen",
	"settings.origin_size": "Pivot Marker",
	"settings.origin_size.desc": "Size of the pivot point marker",
	"settings.control_size": "Transform Gizmo Size",
	"settings.control_size.desc": "Size of the transform gizmo",
	"settings.motion_trails": "Motion Trails",
	"settings.motion_trails.desc": "Show motion trails in the animation editor",
	"settings.save_view_per_tab": "Save View per Tab",
	"settings.save_view_per_tab.desc": "Save the current view angle for each tab separately",
	"settings.display_skin": "Minecraft Skin",
	"settings.display_skin.desc": "Skin used for the reference player model",
	"settings.seethrough_outline": "X-Ray Outlines",
	"settings.seethrough_outline.desc": "Show outlines through objects",
	"settings.brightness": "Brightness",
	"settings.brightness.desc": "Brightness of the preview. Default is 50",
	"settings.shading": "Shading",
	"settings.shading.desc": "Enable shading in the preview",
	"settings.antialiasing": "Anti-aliasing",
	"settings.antialiasing.desc": "Toggle anti-aliasing in the preview",
	"settings.antialiasing_bleed_fix": "Fix anti-aliasing bleeding",
	"settings.antialiasing_bleed_fix.desc": "Fixes texture bleeding when using anti-aliasing. Potentially unsupported on older hardware.",
	"settings.render_sides": "Render Sides",
	"settings.tone_mapping": "Tone Mapping",
	"settings.tone_mapping.desc": "Approximation method for displaying high dynamic range on a standard screen for PBR rendering.",
	"settings.fov": "FOV",
	"settings.fov.desc": "Camera Field of View. Default is 45",
	"settings.camera_near_plane": "Camera Near Plane",
	"settings.camera_near_plane.desc": "The minimum distance from the camera where objects render. Higher values decrease Z-fighting. Default is 1.",
	"settings.maximum_zoom_distance": "Maximum Zoom Distance",
	"settings.maximum_zoom_distance.desc": "How far the camera can be zoomed away from the model",
	"settings.render_sides.desc": "Select which side of a face is rendered",
	"settings.render_sides.auto": "Auto",
	"settings.render_sides.front": "Outside",
	"settings.render_sides.double": "Inside and Outside",
	"settings.constant_outlines": "Constant Outlines",
	"settings.constant_outlines.desc": "Always display element outlines regardless of selection",
	"settings.fps_limit": "FPS Limit",
	"settings.fps_limit.desc": "Limit how many frames per second Blockbench renders. The actual frame rate is limited to what your device can display.",
	"settings.background_rendering": "Background Rendering",
	"settings.background_rendering.desc": "Update the preview while the window is not focused",
	"settings.particle_tick_rate": "Particle Tick Rate",
	"settings.particle_tick_rate.desc": "Tick rate for particle effects in ticks per second. Default is 30",
	"settings.flipbook_textures_in_animation": "Play Flipbook Textures in Animation",
	"settings.flipbook_textures_in_animation.desc": "Preview animations on flipbook textures in sync with the animation timeline",
	"settings.volume": "Volume",
	"settings.volume.desc": "Volume control for sound effects in animations",
	"settings.audio_scrubbing": "Timline Scrubbing Audio",
	"settings.audio_scrubbing.desc": "Play short previews of the audio while scrubbing through time timeline",
	"settings.outliner_colors": "Outliner Colors",
	"settings.outliner_colors.desc": "Display element and group colors in the outliner",
	"settings.preview_checkerboard": "Preview Checkerboard",
	"settings.preview_checkerboard.desc": "Toggle the checkerboard background behind the preview",
	"settings.uv_checkerboard": "UV Editor Checkerboard",
	"settings.uv_checkerboard.desc": "Toggle the checkerboard background behind the UV editor",
	"settings.display_uv": "Display UV Faces",
	"settings.display_uv.desc": "Select which UV faces are displayed in the UV editor",
	"settings.display_uv.selected_faces": "Only selected faces",
	"settings.display_uv.selected_elements": "All faces on selected elements",
	"settings.display_uv.all_elements": "All faces on all elements",
	"settings.timecode_frame_number": "Display Timecodes as Frame Numbers",
	"settings.timecode_frame_number.desc": "Display fraction timecodes in the timeline as frame number instead of centisecond",
	"settings.only_selected_bezier_handles": "Show Only Selected Bézier Handles",
	"settings.only_selected_bezier_handles.desc": "Hide handles of bézier keyframes that are not currently selected",
	"settings.autocomplete_code": "Autocomplete Code",
	"settings.autocomplete_code.desc": "Display autocomplete suggestions in code editors",
	"settings.viewport_rotate_speed": "Viewport Rotate Speed",
	"settings.viewport_rotate_speed.desc": "Input sensitivity when rotating in the viewport",
	"settings.viewport_zoom_speed": "Viewport Zoom Speed",
	"settings.viewport_zoom_speed.desc": "Input sensitivity when zooming in the viewport",
	"settings.editor_2d_zoom_speed": "2D Editor Zoom Speed",
	"settings.editor_2d_zoom_speed.desc": "Input sensitivity when zooming in the UV and 2D paint editor",
	"settings.selection_tolerance": "Selection Tolerance",
	"settings.selection_tolerance.desc": "Size of the area that can be clicked to select an edge or vertex",
	"settings.stretch_linked": "Link Stretching",
	"settings.stretch_linked.desc": "Stretch the cube in all directions with the same value",
	"settings.auto_keyframe": "Auto Keyframe",
	"settings.auto_keyframe.desc": "Automatically create a keyframe with default values at the timeline start when transforming the bone at a later point",
	"settings.detect_flipbook_textures": "Detect Flipbook Textures",
	"settings.detect_flipbook_textures.desc": "Automatically detect flipbook animated textures and preview them as animation",

	"settings.grids": "Show Grids",
	"settings.grids.desc": "Show or hide all 3D grids",
	"settings.base_grid": "Small Grid",
	"settings.base_grid.desc": "Show small grid and axes",
	"settings.large_grid": "Block Grid",
	"settings.large_grid.desc": "Show 16x16 block-size grid",
	"settings.large_grid_size": "Block Grid Size",
	"settings.large_grid_size.desc": "Size of the block grid",
	"settings.full_grid": "Precise Block Grid",
	"settings.full_grid.desc": "Show pixel-precise block grid",
	"settings.large_box": "Size Limit Box",
	"settings.large_box.desc": "Show size limit boundaries",
	"settings.display_grid": "Display Mode Grid",
	"settings.display_grid.desc": "Show grid in display mode",
	"settings.pixel_grid": "Pixel Grid",
	"settings.pixel_grid.desc": "Show texture pixel grid on elements in edit mode",
	"settings.painting_grid": "Painting Grid",
	"settings.painting_grid.desc": "Show grid on textured elements in paint mode",
	"settings.image_editor_grid_size": "Image Editor Grid Size",
	"settings.image_editor_grid_size.desc": "Size of the large grid in the 2D image editor",
	"settings.ground_plane": "Ground Plane",
	"settings.ground_plane.desc": "Show a floor plane below the model",
	"settings.ground_plane_double_side": "Ground Plane Double-sided",
	"settings.ground_plane_double_side.desc": "Make the ground plane visible from below",

	"settings.undo_selections": "Undo Selection",
	"settings.undo_selections.desc": "Track selection changes as a step in the undo history",
	"settings.undo_limit": "Undo Limit",
	"settings.undo_limit.desc": "Number of steps you can undo",
	"settings.local_move": "Move on Relative Axes",
	"settings.local_move.desc": "Move rotated elements on their own axes if possible",
	"settings.canvas_unselect": "Unselect when Clicking Background",
	"settings.canvas_unselect.desc": "Unselects all elements when clicking on the background behind the model or in the timeline",
	"settings.double_click_switch_tools": "Switch Tools on Double Click",
	"settings.double_click_switch_tools.desc": "Double click the viewport to switch between tools",
	"settings.double_click_select_reference": "Select Reference Image on Double Click",
	"settings.double_click_select_reference.desc": "Double click the viewport to select a reference image",
	"settings.highlight_cubes": "Highlight Elements",
	"settings.highlight_cubes.desc": "Highlight elements when you hover over them or select them",
	"settings.outliner_reveal_on_select": "Reveal Elements on Select",
	"settings.outliner_reveal_on_select.desc": "Reveal elements in the ouliner when selected",
	"settings.local_position_values": "Local Position Values",
	"settings.local_position_values.desc": "Display all position values in the Transform panel in local space",
	"settings.transform_cube_from_center": "Transform Cubes from Center",
	"settings.transform_cube_from_center.desc": "Edit the cube position values from the center instead of the corner",
	"settings.deactivate_size_limit": "Deactivate Size Limit",
	"settings.deactivate_size_limit.desc": "Deactivate the size limit for specific model formats. WARNING: This can cause invalid models.",
	"settings.modded_entity_integer_size": "Modded Entity Integer Size",
	"settings.modded_entity_integer_size.desc": "Limit cube sizes in the Modded Entity format to integers. While floats are technically supported in some versions, integers are much easier to UV-map.",
	"settings.allow_display_slot_mirror": "Allow Display Slot Mirroring",
	"settings.allow_display_slot_mirror.desc": "Allow Display slots for Java item models to be mirrored. WARNING: This only works in Minecraft 1.14 or earlier or in special cases.",
	"settings.vertex_merge_distance": "Vertex Merge Distance",
	"settings.vertex_merge_distance.desc": "Distance within which vertices are merged using merging by distance",
	"settings.preview_paste_behavior": "Default Viewport Paste Behavior",
	"settings.preview_paste_behavior.desc": "Select the behavior when pasting something into the viewport in Edit mode and multiple options are available",
	"settings.preview_paste_behavior.always_ask": "Always Ask",

	"settings.autouv": "Auto UV",
	"settings.autouv.desc": "Enable Auto UV by default",
	"settings.default_cube_size": "Cube Size",
	"settings.default_cube_size.desc": "Set the default cube size when creating a new cube",
	"settings.inherit_parent_color": "Inherit Parent Color",
	"settings.inherit_parent_color.desc": "Set the marker color of a newly created element to the color of the parent instead of a random color",
	"settings.create_rename": "Rename New Element",
	"settings.create_rename.desc": "Focus name field when creating new element or group",
	"settings.show_only_selected_uv": "Show Only Selected UV",
	"settings.show_only_selected_uv.desc": "Only display the selected UV faces in the UV editor by default",
	"settings.default_bedrock_format": "Default Bedrock Format",
	"settings.default_bedrock_format.desc": "Select the default format to load Minecraft Bedrock models in, when no specific format can be detected from context.",
	"settings.default_java_block_version": "Default Java Block/Item Version",
	"settings.default_java_block_version.desc": "Default format version when creating new Java block/item models or opening files without format version",
	"settings.animation_snap": "Animation Snap",
	"settings.animation_snap.desc": "Default snap interval for keyframes in the animation timeline in steps per second. This can also be changed per animation. The default value is 24.",
	"settings.default_keyframe_interpolation": "Default Keyframe Interpolation",
	"settings.default_keyframe_interpolation.desc": "Select the default keyframe interpolation mode",
	"settings.uniform_keyframe": "Uniform Scale Keyframes",
	"settings.uniform_keyframe.desc": "Set scale keyframes to uniform scaling by default",
	"settings.new_project_dialog": "New Project Dialog",
	"settings.new_project_dialog.desc": "Show the Project dialog when creating a new project",

	"settings.edit_size": "Grid Resolution",
	"settings.edit_size.desc": "Resolution of the grid that elements snap to",
	"settings.shift_size": "Shift Resolution",
	"settings.shift_size.desc": "Resolution of the grid while holding shift",
	"settings.ctrl_size": "Control Resolution",
	"settings.ctrl_size.desc": "Resolution of the grid while holding control",
	"settings.ctrl_shift_size": "Control + Shift Resolution",
	"settings.ctrl_shift_size.desc": "Resolution of the grid while holding control and shift",
	"settings.negative_size": "Negative Size",
	"settings.negative_size.desc": "Allow the resize tool to use negative sizes",
	"settings.nearest_rectangle_select": "Rectangle Selection: Nearest Edge",
	"settings.nearest_rectangle_select.desc": "Snap rectangle selections to the nearest pixel edge, like in GIMP, instead of entire pixels.",

	"settings.color_picker_style": "Color Picker Style",
	"settings.color_picker_style.desc": "Select the style of the paint mode color picker",
	"settings.pick_color_opacity": "Pick Color Opacity",
	"settings.pick_color_opacity.desc": "Pick the color opacity with the Color Picker and set it as brush opacity",
	"settings.pick_combined_color": "Pick Combined Color",
	"settings.pick_combined_color.desc": "Pick the combined color of all layers at the respective pixel, instead of the color on the active layer",
	"settings.color_picker_tool_switch": "Color Picker Tool Switch",
	"settings.color_picker_tool_switch.desc": "When picking a transparent pixel, switch to the eraser. When the eraser was previously selected and a color is picked, switch to the brush",
	"settings.brush_cursor_2d": "2D Brush Cursor",
	"settings.brush_cursor_2d.desc": "Display an outline around the brush in the 2D workspace",
	"settings.brush_cursor_3d": "3D Brush Cursor",
	"settings.brush_cursor_3d.desc": "Display an outline around the brush in the 3D workspace",
	"settings.outlines_in_paint_mode": "Selection Outlines in Paint Mode",
	"settings.outlines_in_paint_mode.desc": "Display element selection outlines while in paint mode",
	"settings.move_with_selection_tool": "Use Selection Tool to Move Selections",
	"settings.move_with_selection_tool.desc": "Allow the Selection Tool to directly move selections, without having to switch to the Move Layer tool",
	"settings.paint_through_transparency": "Paint Through Transparency",
	"settings.paint_through_transparency.desc": "Paint through transparent pixels when Lock Alpha Channel is enabled",
	"settings.paint_side_restrict": "Restrict Brush to Side",
	"settings.paint_side_restrict.desc": "Restrict brushes to only paint on the current side",
	"settings.opacity_range": "Opacity Range",
	"settings.opacity_range.desc": "Select which range is used to control opacity of layers and brushes",
	"settings.paint_with_stylus_only": "Paint with Stylus Only",
	"settings.paint_with_stylus_only.desc": "Only use the stylus for painting, reserve mouse or touch input for navigation.",
	"settings.limit_brush_opacity_per_stroke": "Limit Brush Opacity per Stroke",
	"settings.limit_brush_opacity_per_stroke.desc": "Limit the opacity that a brush can apply to the value of the opacity slider during each brush stroke. With a smooth brush this behavior can potentially lead to slight unwanted noise.",
	"settings.image_editor": "Image Editor",
	"settings.image_editor.desc": "Default image editor to edit textures with",

	"settings.brush_opacity_modifier": "Brush Opacity Modifier",
	"settings.brush_opacity_modifier.desc": "Modify the brush opacity when using a stylus",
	"settings.brush_size_modifier": "Brush Size Modifier",
	"settings.brush_size_modifier.desc": "Modify the brush size when using a stylus",
	"settings.brush_modifier.pressure": "Pressure",
	"settings.brush_modifier.tilt": "Tilt",
	"settings.brush_modifier.none": "None",

	"settings.dialog.desc": "Show the \"%0\" dialog",

	"settings.json_indentation": "JSON Indentation",
	"settings.json_indentation.desc": "Indentation style for exported JSON files",
	"settings.json_indentation.tabs": "Tabs",
	"settings.json_indentation.spaces_4": "Spaces: 4",
	"settings.json_indentation.spaces_2": "Spaces: 2",
	"settings.final_newline": "Final Newline",
	"settings.final_newline.desc": "Insert a newline character at the end of exported files",
	"settings.minifiedout": "Minified Export",
	"settings.minifiedout.desc": "Write JSON files in one line",
	"settings.minify_bbmodel": "Minified Project Files",
	"settings.minify_bbmodel.desc": "Write .bbmodel files minified into one line",
	"settings.embed_textures": "Embed Textures",
	"settings.embed_textures.desc": "Embed texture file content in .bbmodel files",
	"settings.export_asset_paths": "Export Asset Paths",
	"settings.export_asset_paths.desc": "Select how paths to assets such as textures or animations get saved in .bbmodel files",
	"settings.export_asset_paths.relative": "Relative Paths",
	"settings.export_asset_paths.absolute": "Full Paths",
	"settings.export_asset_paths.both": "Relative & Full Paths (Texture only)",
	"settings.export_asset_paths.none": "No Export",
	"settings.export_empty_groups": "Export Empty Groups",
	"settings.export_empty_groups.desc": "Include groups without content in exported files",
	"settings.export_groups": "Export Groups in Java block/item models",
	"settings.export_groups.desc": "Save groups in java block or item model JSON files",
	"settings.java_export_pivots": "Export Pivots in Java block/item models",
	"settings.java_export_pivots.desc": "Save pivot points in Java block/item models on cubes without rotation",
	"settings.obj_face_export_mode": "OBJ Face Export Mode",
	"settings.obj_face_export_mode.desc": "Choose to let the OBJ exporter convert all faces into tris or quads",
	"settings.obj_face_export_mode.both": "Default",
	"settings.obj_face_export_mode.tris": "Convert to Tris",
	"settings.obj_face_export_mode.quads": "Convert to Quads",
	"settings.optifine_save_default_texture": "OptiFine JEM: Export selected texture",
	"settings.optifine_save_default_texture.desc": "Export the selected texture as the default texture of the model",
	"settings.animation_sample_rate": "Animation Sample Rate",
	"settings.animation_sample_rate.desc": "Sample rate in samples per second for curves that the respective format does not support natively",
	"settings.credit": "Credit Comment",
	"settings.credit.desc": "Add a credit comment to exported files",
	"settings.model_export_scale": "Model Export Scale",
	"settings.model_export_scale.desc": "Factor by which the scale of exported glTF, DAE, and FBX models gets reduced. The default is 16, which converts 16 Blockbench units into 1 meter in the export.",
	"settings.sketchfab_token": "Sketchfab Token",
	"settings.sketchfab_token.desc": "Token to authorize Blockbench to upload to your Sketchfab account",
	"settings.default_path": "Default Minecraft Textures Path",
	"settings.default_path.desc": "Folder from where Blockbench loads default textures",

	"settings.recent_projects": "Recent Model Cap",
	"settings.recent_projects.desc": "Maximum number of recent models to remember",
	"settings.backup_interval": "Backup Interval",
	"settings.backup_interval.desc": "Interval of the automatic backups in minutes",
	"settings.backup_retain": "Backup Retain Duration",
	"settings.backup_retain.desc": "Set how long Blockbench retains old backups in days",
	"settings.automatic_updates": "Automatic Updates",
	"settings.automatic_updates.desc": "Automatically download new versions and keep Blockbench up-to-date",
	"settings.update_to_prereleases": "Update to Pre-releases",
	"settings.update_to_prereleases.desc": "Automatically update to Blockbench beta versions to test new features. Pre-release versions can be unstable, don't enable this option if you rely on Blockbench for work or other important projects.",
	"settings.automatic_plugin_updates": "Automatic Plugin Updates",
	"settings.automatic_plugin_updates.desc": "Automatically update plugins to keep them up-to-date",
	"settings.hardware_acceleration": "Hardware Acceleration",
	"settings.hardware_acceleration.desc": "Outsource rendering tasks to the graphics card",
	"settings.native_window_frame": "Native Window Frame",
	"settings.native_window_frame.desc": "Use a native window frame in the style of the OS",

	"category.navigate": "Navigation",
	"category.tools": "Tools",
	"category.file": "File",
	"category.blockbench": "Blockbench",
	"category.edit": "Edit",
	"category.transform": "Transform",
	"category.select": "Select",
	"category.color": "Color",
	"category.paint": "Paint",
	"category.layers": "Layers",
	"category.view": "View",
	"category.display": "Display Settings",
	"category.animation": "Animation",
	"category.textures": "Textures",
	"category.uv": "UV",
	"category.misc": "Miscellaneous",
	"category.separators": "Separators",

	"keybind.preview_select": "Select",
	"keybind.preview_select.multi_select": "Multi-select",
	"keybind.preview_select.group_select": "Group-select",
	"keybind.preview_select.loop_select": "Loop-select",
	"keybind.preview_rotate": "Rotate View",
	"keybind.preview_drag": "Drag View",
	"keybind.preview_zoom": "Drag-to-Zoom View",
	"keybind.preview_scroll_zoom": "Zoom View",
	"keybind.preview_scroll_pan": "Scroll Pan View",
	"keybind.preview_scroll_pan.desc": "Use scroll to pan the view, can be used for two-finger panning with trackpads",
	"keybind.uv_editor_scroll_zoom": "Zoom UV/2D Editor",
	"keybind.preview_area_select": "Area Select",
	"keybind.paint_secondary_color": "Paint with Secondary Color",
	"keybind.confirm": "Confirm",
	"keybind.cancel": "Cancel",

	"action.slider_pos": "Position %0",
	"action.slider_pos.desc": "Move elements on the %0 axis",
	"action.position_slider_per_element": "Move Individual Positions",
	"action.position_slider_per_element.desc": "When enabled, using the position sliders changes individual positions per element. When disabled, the whole selection moves in the selected transform space.",
	"action.slider_size": "Size %0",
	"action.slider_size.desc": "Resize elements on the %0 axis",
	"action.slider_inflate": "Inflate",
	"action.slider_inflate.desc": "Inflate cubes in all directions without changing the UV",
	"action.slider_stretch": "Stretch",
	"action.slider_stretch.desc": "Stretches cubes multiplicatively on the %0 axis without changing the UV",
	"action.slider_rotation": "Rotation %0",
	"action.slider_rotation.desc": "Rotate elements on the %0 axis",
	"action.origin_slider_direct_values": "Move Pivot Values Directly",
	"action.origin_slider_direct_values.desc": "When enabled, pivot sliders will move the pivot point directly, affecting the position of the object. When disabled, positions get adjusted automatically.",
	"action.slider_origin": "Pivot %0",
	"action.slider_origin.desc": "Move pivot on the %0 axis",
	"action.slider_spline_resolution": "Spline Resolution %0",
	"action.slider_spline_resolution.desc": "Change spline resolution on the %0 axis (%1)",
	"action.slider_spline_resolution.u.desc_precision": "Ring Segments",
	"action.slider_spline_resolution.v.desc_precision": "Tube Segments",
	"action.slider_spline_radius": "Spline Radius",
	"action.slider_spline_radius.desc": "Change spline Radius",
	"action.slider_spline_handle_tilt": "Handle Tilt",
	"action.slider_spline_handle_tilt.desc": "Change spline handle Tilt",
	"action.slider_spline_handle_size": "Handle Size",
	"action.slider_spline_handle_size.desc": "Change spline handle Size",

	"action.fill_mode": "Fill Mode",
	"action.fill_mode.face": "Face",
	"action.fill_mode.selection": "Selection",
	"action.fill_mode.color_connected": "Connected Colors",
	"action.fill_mode.color": "Colors",
	"action.fill_mode.element": "Element",
	"action.fill_mode.selected_elements": "Selected Elements",
	"action.draw_shape_type": "Shape Type",
	"action.draw_shape_type.rectangle": "Rectangle",
	"action.draw_shape_type.rectangle_h": "Rectangle (Hollow)",
	"action.draw_shape_type.ellipse": "Ellipse",
	"action.draw_shape_type.ellipse_h": "Ellipse (Hollow)",
	"action.draw_shape_type.line": "Line",
	"action.copy_brush_mode": "Copy Brush Mode",
	"action.copy_brush_mode.copy": "Copy",
	"action.copy_brush_mode.pattern": "Pattern",
	"action.copy_brush_mode.sample": "Sample",
	"action.brush_lock_mode": "Brush Lock Mode",
	"action.brush_lock_mode.none": "Unlocked",
	"action.brush_lock_mode.element": "Lock to Element",
	"action.brush_lock_mode.face": "Lock to Face",
	"action.brush_lock_mode.selected_faces": "Lock to Selected Faces",
	"action.selection_tool_operation_mode": "Selection Operation Mode",
	"action.selection_tool_operation_mode.create": "New Selection",
	"action.selection_tool_operation_mode.add": "Add to Selection",
	"action.selection_tool_operation_mode.subtract": "Subtract from Selection",
	"action.selection_tool_operation_mode.intersect": "Intersect",
	"action.color_erase_mode": "Erase Mode",
	"action.color_erase_mode.desc": "With erase mode enabled, tools like Fill and Rectangle subtract colors rather than adding them",
	"action.mirror_painting": "Mirror Painting",
	"action.mirror_painting.description": "Mirror your paint strokes to the other side of the model",
	"action.lock_alpha": "Lock Alpha Channel",
	"action.lock_alpha.description": "Lock the transparency of all pixels",
	"action.image_tiled_view": "Tiled View",
	"action.image_tiled_view.description": "Enable the tiled view in the 2D editor",
	"action.image_onion_skin_view": "Image Editor Onion Skin",
	"action.image_onion_skin_view.description": "Enable the onion skin view in the 2D editor",
	"action.slider_brush_size": "Brush Size",
	"action.slider_brush_size.desc": "Radius of the brush in pixels",
	"action.slider_brush_opacity": "Opacity",
	"action.slider_brush_opacity.desc": "Opacity of the brush from 0 to 255",
	"action.slider_brush_softness": "Softness",
	"action.slider_brush_softness.desc": "Softness of the brush in percent",
	"action.slider_brush_aspect_ratio": "Brush Aspect Ratio",
	"action.slider_brush_aspect_ratio.desc": "Aspect ratio of the brush",
	"action.slider_color_select_threshold": "Color Select Threshold",
	"action.slider_color_select_threshold.desc": "How close the color of a neighboring pixel has to be to get selected by color or wand select",
	"action.pixel_perfect_drawing": "Pixel Perfect Drawing",
	"action.pixel_perfect_drawing.desc": "Draw smooth pixel-art lines without double pixels at curves",
	"action.screen_space_brush_projection": "Screen Space Brush Projection",
	"action.screen_space_brush_projection.desc": "Use screen space projection for painting with a brush",
	"action.brush_shape": "Brush Shape",
	"action.brush_shape.square": "Square",
	"action.brush_shape.circle": "Circle",
	"action.blend_mode": "Blend Mode",
	"action.blend_mode.default": "Default",
	"action.blend_mode.set_opacity": "Set Opacity",
	"action.blend_mode.color": "Color",
	"action.blend_mode.behind": "Behind",
	"action.blend_mode.multiply": "Multiply",
	"action.blend_mode.divide": "Divide",
	"action.blend_mode.add": "Add",
	"action.blend_mode.subtract": "Subtract",
	"action.blend_mode.lighten": "Lighten",
	"action.blend_mode.darken": "Darken",
	"action.blend_mode.screen": "Screen",
	"action.blend_mode.overlay": "Overlay",
	"action.blend_mode.hard_light": "Hard Light",
	"action.blend_mode.difference": "Difference",
	"action.blend_mode.alpha_mask": "Alpha Mask",
	"action.expand_texture_selection": "Expand Texture Selection",
	"action.expand_texture_selection.desc": "Expand or shrink the texture selection",

	"action.uv_slider_pos_x": "Move Horizontal",
	"action.uv_slider_pos_x.desc": "Move all selected UV faces horizontally",
	"action.uv_slider_pos_y": "Move Vertical",
	"action.uv_slider_pos_y.desc": "Move all selected UV faces vertically",
	"action.uv_slider_size_x": "Size Horizontal",
	"action.uv_slider_size_x.desc": "Resize all selected UV faces horizontally",
	"action.uv_slider_size_y": "Size Vertical",
	"action.uv_slider_size_y.desc": "Resize all selected UV faces vertically",

	"action.vertex_snap_mode": "Snap Mode",
	"action.vertex_snap_mode.desc": "Select if Vertex Snap moves elements to the selected position or resizes them",
	"action.vertex_snap_mode.move": "Move",
	"action.vertex_snap_mode.scale": "Scale",
	"action.vertex_snap_mode.rotate": "Rotate",

	"action.move_tool": "Move",
	"action.move_tool.desc": "Tool to select and move elements",
	"action.resize_tool": "Resize",
	"action.resize_tool.desc": "Tool to select and resize elements",
	"action.stretch_tool": "Stretch",
	"action.stretch_tool.desc": "Tool to select and stretch elements",
	"action.rotate_tool": "Rotate",
	"action.rotate_tool.desc": "Tool to select and rotate elements",
	"action.pivot_tool": "Pivot Tool",
	"action.pivot_tool.desc": "Tool to change the pivot point of elements and bones",
	"action.knife_tool": "Knife Tool",
	"action.knife_tool.desc": "Tool to cut mesh faces into smaller pieces",
	"action.seam_tool": "Seam Tool",
	"action.seam_tool.desc": "Tool to define UV seams on mesh edges",
	"action.weight_brush": "Weight Brush",
	"action.weight_brush.desc": "Paint vertex weights on meshes for armature deformations",
	"action.pan_tool": "Pan Tool",
	"action.pan_tool.desc": "Tool to navigate in the viewport and the texture editor",
	"action.brush_tool": "Paint Brush",
	"action.brush_tool.desc": "Colored brush to draw on textures",
	"action.copy_brush": "Copy Brush",
	"action.copy_brush.desc": "Brush to clone parts of your texture or draw patterns. Hold Ctrl and click to select a copy source.",
	"action.fill_tool": "Paint Bucket",
	"action.fill_tool.desc": "Paint bucket to fill entire faces with one color",
	"action.eraser": "Eraser",
	"action.eraser.desc": "Eraser tool to replace colors on a texture with transparency",
	"action.color_picker": "Color Picker",
	"action.color_picker.desc": "Tool to pick the color of pixels on your texture",
	"action.draw_shape_tool": "Draw Shape",
	"action.draw_shape_tool.desc": "Tool to draw simple shapes on textures",
	"action.gradient_tool": "Gradient Tool",
	"action.gradient_tool.desc": "Create a color gradient on your texture",
	"action.selection_tool": "Selection Tool",
	"action.selection_tool.desc": "Select parts of the image",
	"action.selection_tool.rectangle": "Rectangle",
	"action.selection_tool.ellipse": "Ellipse",
	"action.selection_tool.lasso": "Lasso Select",
	"action.selection_tool.wand": "Magic Wand",
	"action.selection_tool.color": "Same Color",
	"action.move_layer_tool": "Move Layer",
	"action.move_layer_tool.desc": "Move the current layer or selection",
	"action.toggle_skin_layer": "Toggle Skin Layer",
	"action.toggle_skin_layer.desc": "Toggle the hat and clothing layer of the skin model",
	"action.convert_minecraft_skin_variant": "Convert Slim/Wide Skin",
	"action.convert_minecraft_skin_variant.desc": "Switch the skin model between the classic wide (steve) model and the slim (alex) model. Optionally auto-adjust the texture to fit the model",
	"action.explode_skin_model": "Explode Skin Model",
	"action.explode_skin_model.desc": "Toggles an explosion view that allows you to edit covered faces",
	"action.custom_skin_poses": "Custom Skin Poses",
	"action.custom_skin_poses.desc": "Load a custom skin pose preset",
	"action.custom_skin_poses.update": "Update Pose",
	"action.custom_skin_poses.update.desc": "Overwrite the saved pose with the current pose of the model",
	"action.add_custom_skin_pose": "Add Custom Skin Pose",
	"action.add_custom_skin_pose.desc": "Save the current pose of the model as a pose preset",

	"action.vertex_snap_tool": "Vertex Snap",
	"action.vertex_snap_tool.desc": "Move one cube to another cube by connecting two vertices",
	"action.swap_tools": "Swap Tools",
	"action.swap_tools.desc": "Switch between alternative tools, like move and resize, or brush and color picker",
	"action.swap_tools.hold": "Hold to swap (Color Picker)",

	"action.project_window": "Project...",
	"action.project_window.desc": "Opens the project window, where you can edit metadata of your model",
	"action.new_window": "New Window",
	"action.new_window.desc": "Opens a new Blockbench window",
	"action.open_model_folder": "Open Model Folder",
	"action.open_model_folder.desc": "Opens the folder that the model is contained in",
	"action.view_backups": "View Backups",
	"action.view_backups.desc": "Browse the list of auto-saved project backups",
	"action.open_model": "Open Model",
	"action.open_model.desc": "Open a model file from your computer",
	"action.open_from_link": "Open Model from Link...",
	"action.open_from_link.desc": "Open a model from a blckbn.ch URL",
	"action.duplicate_project": "Duplicate Project",
	"action.duplicate_project.desc": "Creates a copy of the open project",
	"action.convert_project": "Convert Project",
	"action.convert_project.desc": "Converts the current project to a project for another model format",
	"action.close_project": "Close Project",
	"action.close_project.desc": "Closes the currently open project",
	"action.close_other_projects": "Close Other Tabs",
	"action.close_other_projects.desc": "Closes all projects except the open project",
	"action.close_projects_to_right": "Close Tabs to the Right",
	"action.close_projects_to_right.desc": "Closes all project tabs to the right of the open project",
	"action.tab_overview": "Tab Overview",
	"action.tab_overview.desc": "View all open tabs in a grid and jump to one",
	"action.switch_tabs": "Switch Tabs",
	"action.switch_tabs.desc": "Cycle between opened tabs. Hold shift to cycle in the opposite direction.",
	"action.switch_tabs.reverse_order": "Reverse order",
	"action.validator_window": "View Model Issues...",
	"action.validator_window.desc": "Opens the validator, which lists issues with the current model.",
	"action.import_obj": "Import OBJ Model",
	"action.import_obj.desc": "Imports objects from an OBJ model as meshes",
	"action.import_java_block_model": "Add Java Block/Item Model",
	"action.import_java_block_model.desc": "Add a Minecraft Java block/item model from a json file to the current model",
	"action.import_bedrock_voxel_shape": "Import Bedrock Voxel Shape",
	"action.import_bedrock_voxel_shape.desc": "Add a voxel shape from a json file to the current project",
	"action.extrude_texture": "Extruded Texture",
	"action.extrude_texture.desc": "Generate a model by stretching out a texture",
	"action.extrude_texture_to_model": "Extrude Texture",
	"action.extrude_texture_to_model.desc": "Generate a model by extruding this texture",
	"action.export_blockmodel": "Export Block/Item Model",
	"action.export_blockmodel.desc": "Export a Minecraft Java Edition block or item model",
	"action.export_asset_archive": "Download Archive",
	"action.export_asset_archive.desc": "Download an archive with the model and all textures in it",
	"action.export_bedrock": "Export Bedrock Geometry",
	"action.export_bedrock.desc": "Export the model as a bedrock edition geometry file.",
	"action.export_bedrock_voxel_shape": "Export Bedrock Voxel Shape",
	"action.export_bedrock_voxel_shape.desc": "Export the bounding boxes in the project as a bedrock voxel shape file",
	"action.export_entity": "Export Bedrock Entity",
	"action.export_entity.desc": "Export the model as an entity model for Minecraft Bedrock Edition",
	"action.export_class_entity": "Export Java Entity",
	"action.export_class_entity.desc": "Export the entity model as a Java class",
	"action.export_modded_animations": "Export Modded Entity Animations",
	"action.export_modded_animations.desc": "Export animations for a Minecraft Java Edition modded entity model",
	"action.import_optifine_part": "Import OptiFine Part",
	"action.import_optifine_part.desc": "Import an entity part model for OptiFine",
	"action.export_optifine_full": "Export OptiFine JEM",
	"action.export_optifine_full.desc": "Export a full OptiFine entity model",
	"action.export_optifine_part": "Export OptiFine Part",
	"action.export_optifine_part.desc": "Export a single part for an OptiFine entity model",
	"action.export_minecraft_skin": "Export Minecraft Skin",
	"action.export_minecraft_skin.desc": "Export the Minecraft skin as a PNG texture",
	"action.export_image": "Export Image",
	"action.export_image.desc": "Export your texture as an image file",
	"action.export_obj": "Export OBJ Model",
	"action.export_obj.desc": "Export a Wavefront OBJ model for rendering",
	"action.export_stl": "Export STL",
	"action.export_stl.desc": "Export a STL model for 3D printing",
	"action.export_collada": "Export Collada Model (dae)",
	"action.export_collada.desc": "Export model and animations as dae file to use it in other 3D applications",
	"action.export_fbx": "Export FBX Model",
	"action.export_fbx.desc": "Export model and animations as fbx file to use it in other 3D applications and game engines",
	"action.export_gltf": "Export glTF Model",
	"action.export_gltf.desc": "Export model and animations as glTF file for sharing and rendering",
	"action.upload_sketchfab": "Upload to Sketchfab...",
	"action.upload_sketchfab.desc": "Upload your model to Sketchfab",
	"action.share_model": "Share...",
	"action.share_model.desc": "Generate a short link to share your model",

	"action.save_project": "Save Project",
	"action.save_project.desc": "Saves the current model as a project file",
	"action.save_project_as": "Save Project As",
	"action.save_project_as.desc": "Saves the current model as a project file at a new location",
	"action.save_project_incremental": "Save Project With Increment",
	"action.save_project_incremental.desc": "Saves the current model as a project file with an increment (ex: project_2.bbmodel)",
	"action.import_project": "Import Project",
	"action.import_project.desc": "Import another project from a .bbmodel file into the current project",
	"action.export_over": "Save Model",
	"action.export_over.desc": "Saves the model, textures and animations by overwriting the files",

	"action.settings_window": "Settings...",
	"action.settings_window.desc": "Open the Blockbench settings dialog.",
	"action.plugins_window": "Plugins...",
	"action.plugins_window.desc": "Open the plugin store window",
	"action.plugins_window_menu": "Menu",
	"action.action_control": "Action Control",
	"action.action_control.desc": "Search and execute any available action",
	"action.edit_session": "Edit Session...",
	"action.edit_session.desc": "Connect to an edit session to collaborate with other users",
	"action.add_plugin": "Install Plugin",
	"action.add_plugin.desc": "Install a plugin through Action Control",
	"action.remove_plugin": "Uninstall Plugin",
	"action.remove_plugin.desc": "Uninstall a plugin through Action Control",
	"action.experimental_settings": "Experimental Settings",
	"action.experimental_settings.desc": "Customize experimental developer settings",

	"action.load_plugin": "Load Plugin from File",
	"action.load_plugin.desc": "Load a plugin by importing the source file",
	"action.load_plugin_from_url": "Load Plugin from URL",
	"action.load_plugin_from_url.desc": "Load a plugin from a server by specifying the URL",
	"action.copy_installed_plugins": "Copy Installed Plugins",
	"action.copy_installed_plugins.desc": "Generate and copy a list of the currently installed plugins",
	"action.install_plugins_from_list": "Install Plugins from List",
	"action.install_plugins_from_list.desc": "Install plugins from a list of plugin IDs",
	"action.reload_plugins": "Reload Plugins",
	"action.reload_plugins.desc": "Reload all development plugins",

	"action.import_settings": "Import Settings",
	"action.import_settings.desc": "Import a .bbsettings file",
	"action.export_settings": "Export Settings",
	"action.export_settings.desc": "Export the Blockbench settings as a .bbsettings file",
	
	"action.load_keymap": "Load Keymap",
	"action.load_keymap.default": "Default (Trackpad/Mouse)",
	"action.load_keymap.mouse": "Default (Mouse)",
	"action.load_keymap.default.desc": "Default Blockbench keybindings, with viewport navigation controls optimized for use on laptop trackpads",
	"action.load_keymap.mouse.desc": "Default Blockbench keybindings, with viewport navigation bound to the middle mouse button",
	"action.load_keymap.blender.desc": "Keymap for users who are familiar with the controls of Blender",
	"action.load_keymap.cinema4d.desc": "Keymap for users who are familiar with the controls of Cinema 4D",
	"action.load_keymap.maya.desc": "Keymap for users who are familiar with the controls of Autodesk Maya",
	"action.import_keymap": "Import Keymap",
	"action.import_keymap.desc": "Import keybindings a .bbkeymap file",
	"action.export_keymap": "Export Keymap",
	"action.export_keymap.desc": "Export the current keybindings as a .bbkeymap file",

	"action.reset_layout": "Reset Layout",
	"action.reset_layout.desc": "Reset the layout to Blockbench's default",
	"action.import_theme": "Import Theme",
	"action.export_theme": "Export Theme",
	"action.export_theme.desc": "Create a theme file based on the current settings",

	"action.undo": "Undo",
	"action.undo.desc": "Undoes the last change",
	"action.redo": "Redo",
	"action.redo.desc": "Reverts the last undo",
	"action.edit_history": "Edit History...",
	"action.edit_history.desc": "View the editing history and undo or redo steps",
	"action.copy": "Copy",
	"action.copy.desc": "Copy the selected selection, face or display settings",
	"action.copy.multiple": "Copy All",
	"action.copy.multiple.desc": "Copy all available data individually",
	"action.paste": "Paste",
	"action.paste.desc": "Paste the selected selection, face or display settings",
	"action.paste.multiple": "Paste All",
	"action.cut": "Cut",
	"action.cut.desc": "Cut the selected selection, face or display settings",
	"action.add_element": "Add Element",
	"action.add_element.desc": "Add a new element from the list of element types",
	"action.add_cube": "Add Cube",
	"action.add_cube.desc": "Adds a new cube",
	"action.add_bounding_box": "Add Bounding Box",
	"action.add_bounding_box.desc": "Adds a new bounding box",
	"action.add_mesh": "Add Mesh",
	"action.add_mesh.desc": "Adds a new mesh",
	"action.add_spline": "Add Spline",
	"action.add_spline.desc": "Adds a new spline",
	"action.add_locator": "Add Locator",
	"action.add_locator.desc": "Adds a new locator to control positions of particles, leashes etc",
	"action.add_null_object": "Add Null Object",
	"action.add_null_object.desc": "Adds a new null object",
	"action.convert_texture_mesh_to_cubes": "Convert to Extruded Model",
	"action.convert_texture_mesh_to_cubes.desc": "Replace the texture mesh with cubes extruded from its texture, in the same place",
	"action.add_texture_mesh": "Add Texture Mesh",
	"action.add_texture_mesh.desc": "Adds a new Texture Mesh",
	"action.add_billboard": "Add Billboard",
	"action.add_billboard.desc": "Adds a new billboard, a flat element that always faces towards the camera",
	"action.add_armature": "Add Armature",
	"action.add_armature.desc": "Adds an armature that allows deforming a mesh via animation",
	"action.add_armature_bone": "Add Armature Bone",
	"action.add_armature_bone.desc": "Adds a bone to the armature",
	"action.add_group": "Add Group",
	"action.add_group.desc": "Adds a new group or bone",
	"action.group_elements": "Group Elements",
	"action.group_elements.desc": "Wrap selected elements into a new group",
	"action.resolve_group": "Resolve Group",
	"action.resolve_group.desc": "Resolve the group while retaining its children in the same place",
	"action.outliner_toggle": "Toggle More Options",
	"action.outliner_toggle.desc": "Toggles switches for more options in the outliner",
	"action.cube_counter": "Model Statistics",
	"action.cube_counter.desc": "Displays the current number of elements and other statistics",
	"action.search_outliner": "Search Outliner",
	"action.search_outliner.desc": "Search for specific element names in the outliner",
	"action.search_textures": "Search Textures",
	"action.search_textures.desc": "Search for textures by name",
	"action.search_animations": "Search Animations",
	"action.search_animations.desc": "Search for animations by name",
	"action.randomize_marker_colors": "Randomize Marker Colors",

	"action.duplicate": "Duplicate",
	"action.delete": "Delete",
	"action.delete.keep_vertices": "Keep Edges/Vertices",
	"action.move_to_group": "Move to",
	"action.move_to_group.desc": "Move the selected elements to a different outliner group or element",
	"action.sort_outliner": "Sort Outliner",
	"action.sort_outliner.desc": "Sort the outliner alphabetically",
	"action.unlock_everything": "Unlock All",
	"action.unlock_everything.desc": "Unlock all groups and elements in the outliner.",
	"action.element_colors": "Cube Colors",
	"action.element_colors.desc": "Show cube colors in the outliner",
	"action.find_replace": "Find/Replace...",
	"action.find_replace.desc": "Find and replace parts of names",
	"action.select_window": "Select...",
	"action.select_window.desc": "Search and select elements based on their properties",
	"action.invert_selection": "Invert Selection",
	"action.invert_selection.desc": "Invert the current selection",
	"action.select_all": "Select All",
	"action.unselect_all": "Unselect All",
	"action.hide_everything_except_selection": "Hide Everything Except Selection",
	"action.hide_everything_except_selection.desc": "Toggle visibility on all elements except the ones that are selected",
	"action.collapse_groups": "Collapse Groups",
	"action.collapse_groups.desc": "Collapse all groups or nested elements in the outliner",
	"action.unfold_groups": "Unfold Groups",
	"action.unfold_groups.desc": "Unfold all group or nested elementss in the outliner",
	"action.edit_bedrock_binding": "Edit Binding...",
	"action.edit_bedrock_binding.desc": "Change which bone the geometry is bound to",
	"action.element_render_order": "Transparency Render Order",
	"action.element_render_order.short": "Render Order",
	"action.element_render_order.desc": "Render order of elements. This can help fix elements that are hidden behind other elements with transparent textures. Leave it on Auto for opaque elements.",
	"action.element_render_order.default": "Auto",
	"action.element_render_order.behind": "Behind",
	"action.element_render_order.in_front": "In Front",
	"action.cube_light_emission": "Light Emission",
	"action.cube_light_emission.desc": "Change the emissiveness of the selected cubes, as a value between 0 and 15",
	"action.spline_selection_mode": "Spline Selection Mode",
	"action.spline_selection_mode.object": "Object",
	"action.spline_selection_mode.handles": "Handles",
	"action.spline_render_mode": "Geometry",
	"action.spline_render_mode.mesh": "Mesh",
	"action.spline_render_mode.path": "Path",
	"action.spline_render_mode.desc": "Which geometry this spline should render",
	"action.spline_uv_mode": "UV Style",
	"action.spline_uv_mode.length_accurate": "Length Accurate",
	"action.spline_uv_mode.uniform": "Uniform",
	"action.spline_uv_mode.per_segment": "Per Segment",
	"action.spline_uv_mode.desc": "How the spline's tube mesh should lay its UVs",
	"action.spline_ring_segments": "Ring Segments",
	"action.spline_ring_segments.desc": "How many subdivisions this Spline has per Tube Ring",
	"action.spline_tube_segments": "Tube Segments",
	"action.spline_tube_segments.desc": "How many subdivisions this Spline has along its path",
	"action.spline_tube_radius": "Tube Radius",
	"action.spline_tube_radius.desc": "Set the Spline's Tube Radius",
	"spline.shading.flat": "Flat",
	"spline.shading.smooth": "Smooth",
	"spline.shading": "Shading",
	"spline.shading.desc": "How this spline's tube should be shaded",
	"action.spline_display_space": "Display Space",
	"action.spline_display_space.desc": "Display spline space indicators on its path",

	"action.slider_color_h": "Hue",
	"action.slider_color_s": "Saturation",
	"action.slider_color_v": "Value",
	"action.slider_color_red": "Color Red",
	"action.slider_color_green": "Color Green",
	"action.slider_color_blue": "Color Blue",
	"action.swap_colors": "Swap Colors",
	"action.swap_colors.desc": "Swap the main color with the secondary color",
	"action.add_to_palette": "Add To Palette",
	"action.add_to_palette.desc": "Add the selected color to the color palette",
	"action.import_palette": "Import Palette",
	"action.import_palette.desc": "Import a palette file",
	"action.export_palette": "Export Palette",
	"action.export_palette.desc": "Export palette as a .GPL file",
	"action.generate_palette": "Generate Palette...",
	"action.generate_palette.desc": "Generate palette from a texture",
	"action.sort_palette": "Sort Palette",
	"action.sort_palette.desc": "Sort all colors on the palette by color and brightness",
	"action.save_palette": "Save Palette...",
	"action.save_palette.desc": "Save the current color palette inside Blockbench for later use",
	"action.load_palette": "Load Palette",
	"action.load_palette.desc": "Load one of the built-in or saved palette presets",
	"action.slider_palette_color": "Switch Palette Color",
	"action.slider_palette_color.desc": "Cycle between the colors in the palette",
	"action.pick_screen_color": "Pick Screen Color",
	"action.pick_screen_color.desc": "Pick a color from somewhere on your screen",

	"action.transform_space": "Transform Space",
	"action.transform_space.desc": "Default transform space for elements and bones",
	"action.transform_space.global": "Global",
	"action.transform_space.parent": "Parent",
	"action.transform_space.local": "Local",
	"action.transform_space.normal": "Normal",
	"action.spline_handle_mode": "Spline Handle Mode",
	"action.spline_handle_mode.desc": "Which mode to use for transforming spline handles",
	"action.spline_handle_mode.aligned": "Aligned",
	"action.spline_handle_mode.free": "Free",
	"action.spline_handle_mode.mirrored": "Mirrored",
	"action.rotation_space": "Rotation Space",
	"action.transform_pivot_space": "Pivot Transform Space",
	"action.scale": "Scale...",
	"action.scale.desc": "Scale the selected elements",
	"action.rotate_cw": "Rotate %0 +90",
	"action.rotate_cw.desc": "Rotate the selected elements 90° on the %0 axis",
	"action.rotate_ccw": "Rotate %0 -90",
	"action.rotate_ccw.desc": "Rotate the selected elements -90° on the %0 axis",
	"action.flip": "Flip %0",
	"action.flip.desc": "Flip the selected elements on the %0 axis",
	"action.flip_in_place": "Flip in Place %0",
	"action.flip_in_place.desc": "Flip the selected elements on the %0 axis in its current position",
	"action.center": "Center %0",
	"action.center.desc": "Center the selected elements on the %0 axis",
	"action.center_lateral": "Center Lateral",
	"action.center_lateral.desc": "Center the selected elements on the X and Z axis",
	"action.toggle_visibility": "Toggle Visibility",
	"action.toggle_visibility.desc": "Toggle the visibility of the selected elements",
	"action.toggle_export": "Toggle Export",
	"action.toggle_export.desc": "Toggle the export setting of the selected elements",
	"action.toggle_locked": "Toggle Lock",
	"action.toggle_locked.desc": "Toggle whether the selected elements are locked",
	"action.toggle_autouv": "Toggle Auto UV",
	"action.toggle_autouv.desc": "Toggle the auto UV setting of the selected elements",
	"action.toggle_shade": "Toggle Shading",
	"action.toggle_shade.desc": "Toggle the shading of the selected cubes",
	"action.toggle_mirror_uv": "Mirror UV",
	"action.toggle_mirror_uv.desc": "Toggle the UV mirroring on the X axis of the selected cubes",
	"action.rename": "Rename",
	"action.rename.desc": "Change the name of the selected elements or group",
	"action.update_autouv": "Update Auto UV",
	"action.update_autouv.desc": "Update the auto UV mapping of the selected cubes",
	"action.edit_material_instances": "Edit Material Instances",
	"action.edit_material_instances.desc": "Edit material instance names for bedrock block geometries",
	"action.mirror_modeling": "Mirror Modeling",
	"action.mirror_modeling.desc": "Enable Mirror Modeling on the X axis. All changes you make in the viewport will be reflected to the other side, unless specifically disabled on the element.",
	"action.allow_element_mirror_modeling": "Allow Mirror Modeling",
	"action.allow_element_mirror_modeling.desc": "Choose whether the selected elements can be affected by mirror modeling",
	"action.apply_mirror_modeling": "Apply Mirror Modeling",
	"action.apply_mirror_modeling.desc": "Apply Mirror Modeling to the selection. All selected elements will be copied and flipped across the X axis.",
	"action.selection_mode": "Selection Mode",
	"action.selection_mode.desc": "Change how elements can be selected in the viewport",
	"action.selection_mode.object": "Object",
	"action.selection_mode.cluster": "Cluster",
	"action.selection_mode.face": "Face",
	"action.selection_mode.edge": "Edge",
	"action.selection_mode.vertex": "Vertex",
	"action.slider_weight_brush_size": "Weight Brush Size",
	"action.slider_weight_brush_limit": "Weight Brush Limit",
	"action.slider_weight_brush_limit.desc": "Set an upper limit for how much weight the weight brush can assign to a vertex",
	"action.weight_brush_blend_mode": "Weight Brush Blend Mode",
	"action.weight_brush_blend_mode.set": "Set",
	"action.weight_brush_blend_mode.add": "Add",
	"action.weight_brush_xray": "Weight Brush XRay Mode",
	"action.weight_brush_xray.desc": "When enabled, the weight brush will affect all vertices instead of just the ones that are visible on the surface",
	"action.select_seam": "Select UV Seam",
	"action.select_seam.desc": "Select the UV seam mode for the selected edges",
	"action.select_seam.auto": "Auto",
	"action.select_seam.join": "Join",
	"action.select_seam.divide": "Divide",
	"action.create_face": "Create Face or Edge",
	"action.create_face.desc": "Creates a new face or edge between the selected vertices",
	"action.convert_to_mesh": "Convert to Mesh",
	"action.convert_to_mesh.desc": "Convert the selected elements into meshes",
	"action.apply_mesh_rotation": "Apply Rotation",
	"action.apply_mesh_rotation.desc": "Reset the element rotation of the mesh, and apply it to the geometry instead",
	"action.apply_spline_rotation": "Apply Rotation",
	"action.apply_spline_rotation.desc": "Reset the element rotation of the spline, and apply it to the geometry instead",
	"action.invert_face": "Invert Face",
	"action.invert_face.desc": "Invert the selected faces to make them face the opposite direction",
	"action.switch_face_crease": "Switch Face Crease",
	"action.switch_face_crease.desc": "Switch in which direction the quad folds in the middle",
	"action.extrude_mesh_selection": "Extrude Selection",
	"action.extrude_mesh_selection.desc": "Extrude the selected parts of the mesh",
	"action.extrude_spline_selection": "Extrude Spline",
	"action.extrude_spline_selection.desc": "Extrude the selected handle on all splines",
	"action.solidify_mesh_selection": "Solidify Faces",
	"action.solidify_mesh_selection.desc": "Solidify the selected faces of the mesh",
	"action.inset_mesh_selection": "Inset Selection",
	"action.inset_mesh_selection.desc": "Inset the selected parts of the mesh",
	"action.loop_cut": "Loop Cut",
	"action.loop_cut.desc": "Split the mesh in a loop across the selected edge",
	"action.dissolve_edges": "Dissolve Edges",
	"action.dissolve_edges.desc": "Dissolve selected edges in a mesh and merge the faces they divide",
	"action.split_mesh": "Split Mesh",
	"action.split_mesh.desc": "Split the selected faces of the mesh into a new mesh",
	"action.split_spline": "Split Spline",
	"action.split_spline.desc": "Splits the spline into two splines at the selected handle",
	"action.divide_spline_curve": "Divide Spline Segment",
	"action.divide_spline_curve.desc": "Splits the spline segment into two new segments with a new handle at their intersection",
	"action.merge_vertices": "Merge Vertices",
	"action.merge_vertices.desc": "Merge the selected vertices into the position of the first selected vertex",
	"action.merge_vertices.merge_all": "Merge All",
	"action.merge_vertices.merge_all_in_center": "Merge All in Center",
	"action.merge_vertices.merge_by_distance": "Merge by Distance",
	"action.merge_vertices.merge_by_distance_in_center": "Merge by Distance in Center",
	"action.merge_meshes": "Merge Meshes",
	"action.merge_meshes.desc": "Merge multiple meshes into one",
	"action.merge_splines": "Merge Splines",
	"action.merge_splines.desc": "Merge multiple splines into one",
	"action.proportional_editing": "Proportional Editing",
	"action.proportional_editing.desc": "Proportionally affect surrounding vertices when editing parts of a mesh",
	"action.proportional_editing_range": "Proportional Editing Range",
	"action.proportional_editing_range.desc": "Adjust the range for proportional editing",
	"action.set_vertex_weights": "Set Vertex Weights",
	"action.set_vertex_weights.desc": "Set the vertex weights of the selected vertices to a specific value on a certain armature bone",
	"action.calculate_vertex_weights": "Calculate Vertex Weights",
	"action.calculate_vertex_weights.desc": "Automatically assign vertex weights weights based on the position of the bones",

	"action.create_collection": "Create Collection",
	"action.create_collection.desc": "Create a collection out of the outliner selection",
	"action.set_collection_content_to_selection": "Set Collection Content to Selected",
	"action.set_collection_content_to_selection.desc": "Set the selected groups and elements as the content of the collection",
	"action.add_to_collection": "Add Selected to Collection",
	"action.add_to_collection.desc": "Add the selected groups and elements to the collection",

	"action.adjust_brightness_contrast": "Adjust Brightness & Contrast...",
	"action.adjust_brightness_contrast.desc": "Adjust the brightness and contrast of the selected texture",
	"action.adjust_saturation_hue": "Adjust Saturation & Hue...",
	"action.adjust_saturation_hue.desc": "Adjust the saturation and hue of the selected texture",
	"action.invert_colors": "Invert Colors",
	"action.invert_colors.desc": "Invert all colors of the selected texture",
	"action.adjust_opacity": "Adjust Opacity...",
	"action.adjust_opacity.desc": "Adjust the opacity of the selected texture",
	"action.adjust_curves": "Adjust Curves...",
	"action.adjust_curves.desc": "Adjust the brightness curves of the selected texture",
	"action.limit_to_palette": "Limit to Palette",
	"action.limit_to_palette.desc": "Limits the colors of the texture to those in the currently loaded palette",
	"action.split_rgb_into_layers": "Split RGBA Channels into Layers",
	"action.split_rgb_into_layers.desc": "Split the texture into additive layers, one for each RGBA channel",
	"action.split_alpha_into_layer": "Split Alpha Channel into Layer",
	"action.split_alpha_into_layer.desc": "Split the alpha channel of the texture into an alpha mask layer",
	"action.clear_unused_texture_space": "Clear Unused Texture Space",
	"action.clear_unused_texture_space.desc": "Clear parts of the texture that are not UV-mapped to any elements",
	"action.flip_texture_x": "Flip Horizontally",
	"action.flip_texture_x.desc": "Flip the texture or layer horizontally",
	"action.flip_texture_y": "Flip Vertically",
	"action.flip_texture_y.desc": "Flip the texture or layer vertically",
	"action.rotate_texture_cw": "Rotate Clockwise",
	"action.rotate_texture_cw.desc": "Rotate the texture or layer clockwise",
	"action.rotate_texture_ccw": "Rotate Counter-clockwise",
	"action.rotate_texture_ccw.desc": "Rotate the texture or layer counter-clockwise",
	"action.resize_texture": "Resize Texture...",
	"action.animated_texture_editor": "Flipbook Editor...",
	"action.animated_texture_editor.desc": "Edit the flipbook animation of the selected texture",
	"action.crop_texture_to_selection": "Crop Texture to Selection",
	"action.crop_layer_to_selection": "Crop Layer to Selection",

	"action.create_empty_layer": "Create Empty Layer",
	"action.import_layer": "Import Layer",
	"action.import_layer.desc": "Import image files as layers",
	"action.create_layer_group": "Create Layer Group",
	"action.resolve_layer_group": "Resolve Layer Group",
	"action.enable_texture_layers": "Enable Layers",
	"action.disable_texture_layers": "Disable Layers",
	"action.layer_opacity": "Layer Opacity",
	"action.layer_to_texture_size": "Expand Layer to Texture Size",
	"action.layer_to_texture_size.desc": "Expand the layer to the size of the texture",
	"action.merge_layer_down": "Merge Down",
	"action.merge_layer_down.desc": "Merge into the layer below",

	"action.add_display_preset": "New Preset",
	"action.add_display_preset.desc": "Add a new display setting preset",
	"action.apply_display_preset": "Apply Preset",
	"action.apply_display_preset.desc": "Apply a default or custom display setting preset",
	"action.apply_display_preset.here": "Apply To This Slot",
	"action.apply_display_preset.everywhere": "Apply To All Slots",
	"action.gui_light": "GUI Light",
	"action.gui_light.desc": "Select the way the item is lit in the inventory",
	"action.gui_light.side": "Side Light",
	"action.gui_light.front": "Front Light",
	"action.shelf_alignment": "Shelf Alignment",
	"action.shelf_alignment.desc": "Select the vertical alignment of items on the shelf",
	"action.shelf_alignment.top": "Top Alignment",
	"action.shelf_alignment.bottom": "Bottom Alignment",
	"action.predicate_overrides": "Edit Predicate Overrides...",
	"action.predicate_overrides.desc": "Select models to override this model based on selected conditions",
	"action.generate_bedrock_block_box": "Copy Collision/Selection Component",
	"action.generate_bedrock_block_box.desc": "Generate a collision or selection box component for Minecraft Bedrock Edition blocks",
	"action.generate_bedrock_entity_box": "Copy Collision/Hitbox Component",
	"action.generate_bedrock_entity_box.desc": "Generate a collision or custom hit test component for Minecraft Bedrock Edition entities",

	"action.move_up": "Move Up",
	"action.move_up.desc": "Move the selected elements up relative to the current camera angle",
	"action.move_down": "Move Down",
	"action.move_down.desc": "Move the selected elements down relative to the current camera angle",
	"action.move_left": "Move Left",
	"action.move_left.desc": "Move the selected elements left relative to the current camera angle",
	"action.move_right": "Move Right",
	"action.move_right.desc": "Move the selected elements right relative to the current camera angle",
	"action.move_forth": "Move Forth",
	"action.move_forth.desc": "Move the selected elements forth relative to the current camera angle",
	"action.move_back": "Move Back",
	"action.move_back.desc": "Move the selected elements back relative to the current camera angle",

	"action.fullscreen": "Fullscreen",
	"action.fullscreen.desc": "Toggles fullscreen mode",
	"action.zoom_in": "Zoom In",
	"action.zoom_in.desc": "Zoom in to scale up the interface",
	"action.zoom_out": "Zoom Out",
	"action.zoom_out.desc": "Zoom out to scale down the interface",
	"action.zoom_reset": "Reset Zoom",
	"action.zoom_reset.desc": "Reset zoom to the default 100%",
	"action.reset_interface": "Reset Interface",
	"action.reset_interface.desc": "Reset size and positions of the GUI",
	"action.view_mode": "View Mode",
	"action.view_mode.desc": "Change the model view mode",
	"action.view_mode.textured": "Textured",
	"action.view_mode.solid": "Solid",
	"action.view_mode.colored_solid": "Solid with Marker Colors",
	"action.view_mode.wireframe": "Wireframe",
	"action.view_mode.uv": "UV Preview",
	"action.view_mode.normal": "Face Orientation",
	"action.view_mode.vertex_weight": "Vertex Weight",
	"action.view_mode.weighted_bone_colors": "Vertex Bone Colors",
	"action.view_mode.material": "Material Preview",
	"action.preview_scene": "Preview Scene",
	"action.preview_scene.desc": "Change the model preview scene",
	"action.preview_models": "Preview Models",
	"action.preview_models.desc": "Select and edit reference models",
	"action.screenshot_model": "Screenshot Model",
	"action.screenshot_model.desc": "Take a cropped screenshot of the model from the current angle",
	"action.advanced_screenshot": "Advanced Screenshot...",
	"action.advanced_screenshot.desc": "Take a screenshot of the model with advanced options",
	"action.record_model_gif": "Record GIF...",
	"action.record_model_gif.desc": "Record an animated GIF of the model from the current angle",
	"action.cancel_gif": "Cancel GIF",
	"action.timelapse": "Timelapse...",
	"action.timelapse.desc": "Record a timelapse of your modeling process",
	"action.screenshot_app": "Screenshot App",
	"action.screenshot_app.desc": "Take a screenshot of the whole application",
	"action.toggle_sidebars": "Toggle Sidebars",
	"action.toggle_sidebars.desc": "Enable or disable the sidebars",
	"action.image_editor_checkerboard": "Checkerboard",
	"action.image_editor_checkerboard.desc": "Toggle the checkerboard background of the 2D Editor",
	"action.split_screen": "Split Screen",
	"action.split_screen.desc": "Select a viewport split screen mode",
	"action.split_screen.single": "Single",
	"action.split_screen.double_horizontal": "Double Horizontal",
	"action.split_screen.double_vertical": "Double Vertical",
	"action.split_screen.quad": "Quad",
	"action.split_screen.triple_left": "Triple Left",
	"action.split_screen.triple_right": "Triple Right",
	"action.split_screen.triple_top": "Triple Top",
	"action.split_screen.triple_bottom": "Triple Bottom",
	"action.toggle_camera_projection": "Toggle Camera Projection",
	"action.toggle_camera_projection.desc": "Toggle the camera projection between perspective and orthographic",
	"action.load_camera_angle": "Camera Angle: %0",
	"action.load_camera_angle.desc": "Load the camera angle '%0'",
	"action.focus_on_selection": "Center View on Selection",
	"action.focus_on_selection.desc": "Align the camera to face the center of the current selection",
	"action.focus_on_selection.rotate_only": "Rotate only",
	"action.focus_on_selection.zoom": "Zoom to fit",

	"action.edit_reference_images": "Edit Reference Images",
	"action.edit_reference_images.desc": "Turn on reference image mode to add or edit reference images and blueprints",
	"action.add_reference_image": "Add Reference Image",
	"action.reference_image_from_clipboard": "Paste Reference Image",
	"action.toggle_all_reference_images": "Hide/Show All Reference Images",
	"action.toggle_all_reference_images.desc": "Toggle the visibility of all reference images at once",
	"action.reference_image_list": "Reference Images",

	"action.import_texture": "Import Texture",
	"action.import_texture.desc": "Import one or more textures from your file system",
	"action.create_texture": "Create Texture",
	"action.create_texture.desc": "Create a blank texture or template texture",
	"action.create_texture_group": "Create Texture Group",
	"action.create_texture_group.desc": "Create a group for your textures",
	"action.create_material": "Create Material",
	"action.create_material.desc": "Create a new PBR material out of the selected texture",
	"action.generate_pbr_map": "Generate PBR Map...",
	"action.generate_pbr_map.desc": "Generate a PBR map (height map or metalness, emissiveness, roughness) from an existing texture",
	"action.append_to_template": "Append Elements to Template...",
	"action.append_to_template.desc": "Add the currently selected elements to the texture template",
	"action.save_textures": "Save Textures",
	"action.save_textures.desc": "Save all unsaved textures",
	"action.change_textures_folder": "Change Texture Location",
	"action.change_textures_folder.desc": "Change the folder that all textures are saved in",
	"action.apply_texture_to_elements": "Apply Texture to Elements",
	"action.apply_texture_to_elements.desc": "Apply the selected texture to the selected elements",
	"action.refresh_texture": "Refresh Texture",
	"action.refresh_texture.desc": "Reload the texture from file",

	"action.animated_textures": "Play Animated Textures",
	"action.animated_textures.desc": "Play and pause the preview of animated textures",
	"action.animated_texture_frame": "Animated Texture Frame",
	"action.animated_texture_frame.desc": "Set the current frame of the animated texture",
	"action.origin_to_geometry": "Center Pivot",
	"action.origin_to_geometry.desc": "Set the pivot point to the center of the selection",
	"action.center_individual_pivots": "Center Individual Pivots",
	"action.center_individual_pivots.desc": "Set the pivot point of each selected element to its center",
	"action.bone_reset_toggle": "Reset Bone",
	"action.bone_reset_toggle.desc": "Stop the bone from displaying cubes from the parent model",
	"action.reload": "Reload Blockbench",
	"action.reload.desc": "Reload Blockbench. This will void all unsaved progress",

	"action.uv_select_all": "Select All",
	"action.uv_select_all.desc": "Select all faces in the UV dialog",
	"action.uv_rotation": "UV Rotation",
	"action.uv_rotation.desc": "Rotation of the UV face",
	"action.uv_grid": "UV Grid",
	"action.uv_grid.desc": "The resolution of the grid that the UV selector snaps to",
	"action.uv_grid.auto": "Auto",
	"action.uv_apply_all": "Apply To All Faces",
	"action.uv_apply_all.desc": "Applies the settings of the current face to all faces",
	"action.uv_maximize": "Maximize UV",
	"action.uv_maximize.desc": "Sets the UV for this face to the full texture",
	"action.uv_maximize.all_faces": "Affect all faces",
	"action.uv_turn_mapping": "Turn Mapping",
	"action.uv_turn_mapping.desc": "Turn the UV mapping around 90 degrees",
	"action.uv_auto": "Auto UV",
	"action.uv_auto.desc": "Sets the UV size of this face to the real size of the face",
	"action.uv_rel_auto": "Relative Auto UV",
	"action.uv_rel_auto.desc": "Sets the UV of this face to the position and size of the actual face",
	"action.uv_project_from_view": "UV Project from View",
	"action.uv_project_from_view.desc": "Automatically generate UVs for the selected faces from the perspective of the 3D view",
	"action.uv_mirror_x": "UV Mirror X",
	"action.uv_mirror_x.desc": "Mirrors the UV of this face on the X axis",
	"action.uv_mirror_y": "UV Mirror Y",
	"action.uv_mirror_y.desc": "Mirrors the UV of this face on the Y axis",
	"action.uv_rotate_left": "Rotate UV Left",
	"action.uv_rotate_left.desc": "Rotate the selected UV faces counter-clockwise",
	"action.uv_rotate_right": "Rotate UV Right",
	"action.uv_rotate_right.desc": "Rotate the selected UV faces clockwise",
	"action.uv_transparent": "Remove Face",
	"action.uv_transparent.desc": "Removes the current face",
	"action.uv_reset": "Reset Face",
	"action.uv_reset.desc": "Resets the current face",
	"action.cullface": "Cullface",
	"action.cullface.desc": "Disables rendering for this face if the selected side of the model is covered",
	"action.auto_cullface": "Enable Cullface",
	"action.auto_cullface.desc": "Sets the cullface for this face to itself",
	"action.face_tint": "Tint",
	"action.face_tint.desc": "Enables the tint option for the current face",
	"action.slider_face_tint": "Tint Index",
	"action.slider_face_tint.desc": "Set the tint index of the current face. -1 means unset.",
	"action.move_uv_to_cursor": "Move UV to Cursor",
	"action.move_uv_to_cursor.desc": "Move the selected UV faces to the mouse cursor position",
	"action.connect_uv_faces": "Connect UV Faces",
	"action.connect_uv_faces.desc": "Connect the selected UV faces to the last selected UV face",
	"action.merge_uv_vertices": "Merge UV Vertices",
	"action.merge_uv_vertices.desc": "Snap the first selected UV vertices to the last selected UV vertices",
	"action.snap_uv_to_pixels": "Snap UV to Pixels",
	"action.snap_uv_to_pixels.desc": "Snaps the selected UV vertices to the pixel grid",
	"action.uv_cycle": "Cycle UV",
	"action.uv_cycle.desc": "Cycle through the order of UV vertices without changing the UV positions",
	"action.uv_cycle_invert": "Cycle Invert UV",
	"action.uv_cycle_invert.desc": "Reverse the order of UV vertices without changing the UV positions",
	"action.paint_mode_uv_overlay": "UV Overlay",
	"action.paint_mode_uv_overlay.desc": "Display the UV map as an overlay in paint mode",
	"action.edit_mode_uv_overlay": "Display All Elements",
	"action.edit_mode_uv_overlay.desc": "Display the UV map overlay for all elements in edit mode",
	"action.remove_blank_faces": "Remove Blank Faces",
	"action.remove_blank_faces.desc": "Deletes all untextured faces of the selection",
	"action.auto_set_cullfaces": "Set Cullfaces Automatically",
	"action.auto_set_cullfaces.desc": "Automatically generate cullfaces to hide faces when they are covered by the neighboring block.",
	"action.move_texture_with_uv": "Move Texture with UV",
	"action.move_texture_with_uv.desc": "Move the texture of the face along when dragging UV faces",

	"action.add_animation": "Add Animation",
	"action.add_animation.desc": "Create a blank animation",
	"action.add_animation_controller": "Add Animation Controller",
	"action.add_animation_controller.desc": "Create a blank animation controller",
	"action.create_animation_group": "Create Animation Group",
	"action.create_animation_group.desc": "Create a group of animations",
	"action.add_animation_controller_state": "Add Animation Controller State",
	"action.add_animation_controller_state.desc": "Add a new state to the animation controller",
	"action.animation_controller_preview_mode": "Controller Preview",
	"action.animation_controller_preview_mode.paused": "Paused",
	"action.animation_controller_preview_mode.manual": "Manual Preview",
	"action.animation_controller_preview_mode.play": "Auto Play",
	"action.slider_animation_controller_speed": "Controller Playback Speed",
	"action.slider_animation_controller_speed.desc": "The playback speed of animation controllers in percent",
	"action.load_animation_file": "Import Animations",
	"action.load_animation_file.desc": "Import an animation file",
	"action.play_animation": "Play Animation",
	"action.play_animation.desc": "Preview the selected animation",
	"action.save_all_animations": "Save All Animations",
	"action.save_all_animations.desc": "Save all currently loaded animations",
	"action.export_animation_file": "Export Animations...",
	"action.export_animation_file.desc": "Export a selection of animations into a new file",
	"action.optimize_animation": "Optimize Animation",
	"action.optimize_animation.desc": "Optimize the current animation and reduce the keyframe count",
	"action.retarget_animators": "Retarget Animations",
	"action.retarget_animators.desc": "Select which animator targets which bone or element",
	"action.merge_animation": "Merge Animation",
	"action.merge_animation.desc": "Merge the animation into another animation",
	"action.bake_ik_animation": "Bake Inverse Kinematics",
	"action.bake_ik_animation.desc": "Bake the rotations applied by inverse kinematics into the selected animation",
	"action.bake_animation_into_model": "Bake Animation Pose into Model",
	"action.bake_animation_into_model.desc": "Bake the currently displayed animation frame into the model. Only applies rotation and position, scale is ignored.",
	"action.slider_animation_length": "Animation Length",
	"action.slider_animation_length.desc": "Change the length of the selected animation",
	"action.set_animation_end": "Set Animation End",
	"action.set_animation_end.desc": "Set the end of the selected animation to the current timeline time",
	"action.change_animation_speed": "Change Animation Speed...",
	"action.change_animation_speed.desc": "Change the speed of the selected animation",
	"action.slider_keyframe_time": "Timecode",
	"action.slider_keyframe_time.desc": "Change the timecode of the selected keyframes",
	"action.keyframe_interpolation": "Interpolation",
	"action.keyframe_interpolation.desc": "Select the keyframe interpolation mode",
	"action.keyframe_interpolation.linear": "Linear",
	"action.keyframe_interpolation.catmullrom": "Smooth",
	"action.keyframe_interpolation.bezier": "Bézier",
	"action.keyframe_interpolation.step": "Step",
	"action.keyframe_uniform": "Uniform Scaling",
	"action.keyframe_uniform.desc": "Enable uniform scaling on the selected keyframes",
	"action.keyframe_bezier_linked": "Link Bézier Handles",
	"action.keyframe_bezier_linked.desc": "Connect the right and left keyframe bézier handle",
	"action.reset_keyframe": "Reset Keyframe",
	"action.reset_keyframe.desc": "Reset all values of the selected keyframes",
	"action.reset_keyframe_handles": "Reset Keyframe Handles",
	"action.reset_keyframe_handles.desc": "Reset the bézier handles of the selected keyframes",
	"action.round_keyframe_values": "Round Keyframe Values",
	"action.round_keyframe_values.desc": "Round all values of the selected keyframes",
	"action.resolve_keyframe_expressions": "Resolve Keyframe",
	"action.resolve_keyframe_expressions.desc": "Resolves the math expressions of the selected keyframes",
	"action.reverse_keyframes": "Reverse Keyframes",
	"action.reverse_keyframes.desc": "Reverse the order of the selected keyframes",
	"action.keyframe_column_create": "Create Keyframe Column",
	"action.keyframe_column_create.desc": "Key all channels in the timeline at the current timecode, if they already have keyframes",
	"action.keyframe_column_create.all_channels": "All Channels",
	"action.keyframe_column_create.all_channels.desc": "Initialize all channels with keyframes even if they had no keyframes previously",
	"action.keyframe_column_select": "Select Keyframe Column",
	"action.keyframe_column_select.desc": "Select all keyframes in the timeline along a column below the playhead",
	"action.keyframe_select_before_playhead": "Select Keyframes Before Playhead",
	"action.keyframe_select_before_playhead.desc": "Select all keyframes in the timeline at or before the playhead",
	"action.keyframe_select_after_playhead": "Select Keyframes After Playhead",
	"action.keyframe_select_after_playhead.desc": "Select all keyframes in the timeline at or after the playhead",
	"action.flip_animation": "Flip Animation",
	"action.flip_animation.desc": "Flips part of an animation by copying selected keyframes to the other side of the model",
	"action.delete_keyframes": "Delete Keyframes",
	"action.delete_keyframes.desc": "Delete all selected keyframes",
	"action.save_animation_preset": "Save Animation Preset...",
	"action.save_animation_preset.desc": "Save the selected keyframes as an animation preset",
	"action.slider_animation_speed": "Playback Speed",
	"action.slider_animation_speed.desc": "Playback speed of the timeline in percent",
	"action.add_keyframe": "Add Keyframe",
	"action.add_keyframe.desc": "Add a keyframe to the selected animator",
	"action.add_keyframe.reset_values": "With default values",
	"action.add_marker": "Set Marker",
	"action.add_marker.desc": "Set a timeline marker",
	"action.timeline_setups": "Timeline Setups",
	"action.save_timeline_setup": "Save Timeline Setup...",
	"action.save_timeline_setup.desc": "Save a preset for the currently selected animators and channels",
	"action.move_keyframe_back": "Move Keyframes Back",
	"action.move_keyframe_forth": "Move Keyframes Forth",
	"action.move_graph_keyframes_up": "Move Keyframe Graph Up",
	"action.move_graph_keyframes_down": "Move Keyframe Graph Down",
	"action.previous_keyframe": "Previous Keyframe",
	"action.previous_keyframe.desc": "Jump to the previous keyframe",
	"action.next_keyframe": "Next Keyframe",
	"action.next_keyframe.desc": "Jump to the next keyframe",
	"action.jump_to_timeline_start": "Jump to Animation Start",
	"action.jump_to_timeline_end": "Jump to Animation End",
	"action.timeline_frame_back": "Jump 1 Frame Back",
	"action.timeline_frame_forth": "Jump 1 Frame Forth",
	"action.set_timeline_range_start": "Set Timeline Range Start",
	"action.set_timeline_range_start.desc": "Set the start point for a custom playback range in the animation timeline",
	"action.set_timeline_range_end": "Set Timeline Range End",
	"action.set_timeline_range_end.desc": "Set the end point for a custom playback range in the animation timeline",
	"action.disable_timeline_range": "Disable Timeline Range",
	"action.disable_timeline_range.desc": "Disable the custom playback range in the animation timeline",
	"action.bring_up_all_animations": "Bring Up All Animators",
	"action.bring_up_all_animations.desc": "Brings all modified animators into the timeline",
	"action.fold_all_animations": "Fold All Animators",
	"action.add_all_to_timeline": "Add All to Timeline",
	"action.clear_timeline": "Clear Timeline",
	"action.clear_timeline.desc": "Clear all unselected bones from the timeline",
	"action.select_effect_animator": "Animate Effects",
	"action.select_effect_animator.desc": "Opens timeline to add sound and particle effects",
	"action.timeline_graph_editor": "Toggle Graph Editor",
	"action.timeline_graph_editor.desc": "Toggle the timeline between graph editor view and keyframe view",
	"action.graph_editor_zero_line": "Include Zero Line",
	"action.graph_editor_zero_line.desc": "Whether the graph editor always includes the zero line in the view",
	"action.graph_editor_other_graphs": "Display Other Graphs",
	"action.graph_editor_other_graphs.desc": "Whether the graphs of the axes that are not selected are displayed",
	"action.graph_editor_include_other_graphs": "Include Other Graphs",
	"action.graph_editor_include_other_graphs.desc": "Whether the graph editor includes the graphs that are not selected in the view",
	"action.timeline_focus": "Filter Channels",
	"action.timeline_focus.desc": "Select the animation channels to display in the timeline",
	"action.timeline_focus.hide_empty": "Hide empty channels",
	"action.set_ik_target": "Set IK Target",
	"action.set_ik_target.desc": "Select the target bone that should be moved by this null object via Inverse Kinematics",
	"action.set_ik_source": "Set IK Root",
	"action.set_ik_source.desc": "Select the root bone of the chain that should be moved by this null object via Inverse Kinematics",
	"action.set_ik_pole": "Set IK Pole",
	"action.set_ik_pole.desc": "Select the pole that the chain will attempt to face towards while moving",
	"action.lock_motion_trail": "Lock Motion Trail",
	"action.lock_motion_trail.desc": "Lock the motion trail to the currently selected group",
	"action.mirror_animating": "Mirror Animating",
	"action.mirror_animating.desc": "Mirror animation edits to the opposite side",
	"action.animation_onion_skin": "Animation Onion Skin",
	"action.animation_onion_skin.desc": "Display an wireframe view of a different frame in the animation for reference",
	"action.looped_animation_playback": "Looped Playback",
	"action.looped_animation_playback.desc": "Preview animations in an infinite loop",
	"action.apply_animation_preset": "Apply Animation Preset",
	"action.apply_animation_preset.desc": "Select from a list of animation presets and apply it to the selected bone",
	"action.bedrock_animation_mode": "Bedrock Animation Mode",
	"action.bedrock_animation_mode.desc": "Select the mode to edit animations for Minecraft: Bedrock Edition in",
	"action.bedrock_animation_mode.entity": "Entity",
	"action.bedrock_animation_mode.attachable_first": "Item 1st Person",
	"action.bedrock_animation_mode.attachable_third": "Item 3rd Person",
	"action.copy_animation_pose": "Copy Animation Pose",
	"action.copy_animation_pose.desc": "Copy all keyframes to replicate the current animation pose",
	"action.create_variable_placeholder": "Create Variable Placeholder",
	"action.create_variable_placeholder.desc": "Add a variable to the variable placeholders list to preview a value",
	"action.view_built_in_variables": "View Built-in Variables",
	"action.view_built_in_variables.desc": "Display the list of variables and their values that Blockbench automatically provides for animation preview",

	"timeline.rotation": "Rotation",
	"timeline.position": "Position",
	"timeline.scale": "Scale",
	"timeline.particle": "Particle",
	"timeline.sound": "Sound",
	"timeline.effects": "Effects",
	"timeline.timeline": "Instructions",
	"timeline.pre_effect_script": "Script",
	"timeline.bind_to_actor": "Bind to Actor",
	"timeline.amplify": "Amplify",
	"timeline.select_particle_file": "Select Particle File",
	"timeline.select_sound_file": "Select Sound File",

	"animation_controllers.select_preset": "Select a controller preset...",
	"animation_controllers.state.animations": "Animations",
	"animation_controllers.state.particles": "Particles",
	"animation_controllers.state.sounds": "Sounds",
	"animation_controllers.state.on_entry": "On Entry",
	"animation_controllers.state.on_exit": "On Exit",
	"animation_controllers.state.transitions": "Transitions",
	"animation_controllers.state.condition": "Condition",
	"animation_controllers.state.blend_transition": "Blend Time",
	"animation_controllers.state.blend_transition_curve": "Blend Transition Curve",
	"animation_controllers.state.shortest_path": "Blend by Shortest Path",
	"animation_controllers.state.edit_transition": "Edit Transition",

	"menu.action_control.type.tab": "Tab",
	"menu.action_control.type.angle": "Camera Angle",
	"menu.action_control.recent_in_streamer_mode": "Sure? Streamer Mode is enabled",
	"menu.action_control.recent_in_streamer_mode.desc": "Are you sure you want to display recent models?",

	"menu.options": "Options...",

	"menu.slider.round_value": "Round Value",
	"menu.slider.reset_vector": "Reset Vector",

	"menu.file": "File",
	"menu.edit": "Edit",
	"menu.transform": "Transform",
	"menu.mesh": "Mesh",
	"menu.skin": "Skin",
	"menu.uv": "UV",
	"menu.texture": "Texture",
	"menu.image": "Image",
	"menu.paint": "Paint",
	"menu.tools": "Tools",
	"menu.display": "Display",
	"menu.animation": "Animation",
	"menu.keyframe": "Keyframe",
	"menu.view": "View",
	"menu.help": "Help",

	"menu.file.new": "New",
	"menu.file.recent": "Recent",
	"menu.file.recent.clear": "Clear Recent Files",
	"menu.file.recent.more": "View More...",
	"menu.file.import": "Import",
	"menu.file.import.import_open_project": "Import Open Project",
	"menu.file.export": "Export",
	"menu.file.preferences": "Preferences",
	"menu.transform.rotate": "Rotate",
	"menu.transform.flip": "Flip",
	"menu.transform.center": "Center",
	"menu.transform.properties": "Properties",
	"menu.tools.main_tools": "Toolbox",
	"menu.display.preset": "Apply Preset",
	"menu.display.preset_all": "Apply Preset Everywhere",
	"menu.display.remove_preset": "Remove Preset",
	"menu.view.zoom": "Zoom",
	"menu.view.panels": "Panels",
	"menu.view.background": "Background",
	"menu.view.screenshot": "Screenshot",

	"menu.help.discord": "Discord Server",
	"menu.help.wiki": "Blockbench Wiki",
	"menu.help.quickstart": "Quickstart Wizard",
	"menu.help.report_issue": "Report an Issue",
	"menu.help.plugin_documentation": "Plugin API Documentation",
	"menu.help.search_action": "Search and Run Action",
	"menu.help.donate": "Donate",
	"menu.help.about": "About...",
	"menu.help.developer": "Developer",
	"menu.help.developer.dev_tools": "Open Dev Tools",
	"menu.help.developer.reset_storage": "Factory Reset",
	"menu.help.unlock_projects": "Unlock All Projects",
	"menu.help.developer.reset_storage.confirm": "Are you sure you want to reset Blockbench to factory settings? This will delete all custom settings, keybindings and installed plugins.",
	"menu.help.developer.cache_reload": "Cache Reload",
	"menu.help.updating": "Updating (%0%)",
	"menu.help.update_failed": "Update Failed",

	"menu.text_edit.copy_vector": "Copy Vector",
	"menu.text_edit.expression_editor": "Expression Editor",

	"menu.cube.color": "Marker Color",
	"menu.cube.texture": "Texture",
	"menu.cube.texture.transparent": "Transparent",
	"menu.cube.texture.blank": "Blank",
	"menu.cube.texture.default": "Default",
	"menu.locator.ignore_inherited_scale": "Ignore Inherited Scale",
	"menu.null_object.lock_ik_target_rotation": "Lock IK Target Rotation",

	"menu.group.sort": "Sort",

	"menu.brush_presets.dialog": "Brush Presets...",
	"menu.brush_presets.pixel_brush": "Pixel Brush",
	"menu.brush_presets.pixel_perfect": "Pixel-perfect Brush",
	"menu.brush_presets.smooth_brush": "Smooth Brush",
	"menu.brush_presets.screen_space": "Screen Space Brush",

	"menu.palette.load.default": "Default",
	"menu.palette.load.empty": "Blank",
	"menu.palette.load.update": "Update Palette",
	"menu.palette.load.update.desc": "Updates this palette with the colors of the current Blockbench palette",
	"menu.palette.lock_palette": "Lock Palette",

	"menu.color_picker.picker_type": "Picker Type",
	"menu.color_picker.picker_type.square": "Square",
	"menu.color_picker.picker_type.wheel": "Wheel",
	"menu.color_picker.picker_type.normal": "Normal Map",
	"menu.color_picker.slider_mode": "Slider Mode",
	"menu.color_picker.slider_mode.hsv": "Hue, Saturation, Value",
	"menu.color_picker.slider_mode.rgb": "Red, Green, Blue",

	"menu.texture.face": "Apply to Face",
	"menu.texture.blank": "Apply to Untextured Faces",
	"menu.texture.elements": "Apply to Elements",
	"menu.texture.file": "File",
	"menu.texture.refresh": "Refresh",
	"menu.texture.discard_changes": "Discard Changes",
	"menu.texture.discard_changes.desc": "Discard all unsaved changes and load the latest version from the file",
	"menu.texture.change": "Change File",
	"menu.texture.folder": "Show in File Explorer",
	"menu.texture.file_format": "File Format",
	"menu.texture.render_mode": "Render Mode",
	"menu.texture.render_mode.default": "Default",
	"menu.texture.render_mode.emissive": "Emissive",
	"menu.texture.render_mode.additive": "Additive",
	"menu.texture.render_mode.layered": "Layered",
	"menu.texture.wrap_mode": "Wrap Mode",
	"menu.texture.wrap_mode.limited": "Restricted",
	"menu.texture.wrap_mode.repeat": "Repeat",
	"menu.texture.wrap_mode.clamp": "Clamp Edge",
	"menu.texture.pbr_channel": "PBR Channel",
	"menu.texture.pbr_channel.color": "Color",
	"menu.texture.pbr_channel.normal": "Normal",
	"menu.texture.pbr_channel.height": "Height",
	"menu.texture.pbr_channel.mer": "MER (Metalness-Emissive-Roughness)",
	"menu.texture.pbr_channel.mer_subsurface": "MER Subsurface",
	"menu.texture.flipbook_animation": "Flipbook Animation",
	"menu.texture.merge_onto_texture": "Merge Onto Texture Above",
	"menu.texture.edit": "Edit",
	"menu.texture.edit_externally": "Edit Externally",
	"menu.texture.edit_in_blockbench": "Edit in Blockbench",
	"menu.texture.particle": "Use for Particles",
	"menu.texture.particle.clear": "Stop using for Particles",
	"menu.texture.use_as_default": "Set as Default",
	"menu.texture.use_as_default.clear": "Unassign as Default",
	"menu.texture.export": "Save As",
	"menu.texture.save": "Save",
	"menu.texture.properties": "Properties...",

	"menu.texture_group.resolve": "Resolve",

	"menu.collection.open_file": "Open File",
	"menu.collection.export_project": "Export Project",
	"menu.collection.export_as": "Export as \"%0\"",

	"menu.preview.background": "Background",
	"menu.preview.background.load": "Load",
	"menu.preview.background.clipboard": "Load from Clipboard",
	"menu.preview.background.position": "Position",
	"menu.preview.background.set_position": "Set Position",
	"menu.preview.background.lock": "Lock To Camera",
	"menu.preview.screenshot": "Screenshot",

	"menu.preview.orthographic": "Orthographic",
	"menu.preview.save_angle": "Save Angle...",
	"menu.preview.angle": "Angles",
	"menu.preview.angle.initial": "Initial Angle",
	"menu.preview.angle.edit": "Edit Angle...",

	"menu.preview.perspective": "Perspective",
	"menu.preview.perspective.normal": "Normal",
	"menu.preview.perspective.reset": "Reset Camera",
	"menu.preview.quadview": "Quad View",
	"menu.preview.maximize": "Maximize",
	"menu.preview.stop_drag": "Stop Background Positioning",

	"menu.uv.export": "Export UV Mapping",
	"menu.uv.mapping.rotation": "Rotation",
	"menu.uv.flip_x": "Mirror X",
	"menu.uv.flip_y": "Mirror Y",
	"menu.uv.texture": "Texture",

	"menu.panel.enable": "Enable",
	"menu.panel.reset_size": "Reset Size",
	"menu.panel.move_to": "Move To",
	"menu.panel.attach_to": "Attach To",
	"menu.panel.move_to.left_bar": "Left Sidebar",
	"menu.panel.move_to.right_bar": "Right Sidebar",
	"menu.panel.move_to.top": "Top",
	"menu.panel.move_to.bottom": "Bottom",
	"menu.panel.move_to.float": "Float",
	"menu.panel.move_to.hidden": "Hide",
	"menu.panel.fold": "Collapse",

	"menu.mirror_painting.enabled": "Enabled",
	"menu.mirror_painting.axis": "Axis",
	"menu.mirror_painting.axis.desc": "Select on which axis paint strokes will get mirrored",
	"menu.mirror_painting.global": "Global Symmetry",
	"menu.mirror_painting.global.desc": "Enabled mirror painting on the model in global space",
	"menu.mirror_painting.local": "Local Symmetry",
	"menu.mirror_painting.local.desc": "Enable mirror painting in local space for each element",
	"menu.mirror_painting.texture": "2D Editor Symmetry",
	"menu.mirror_painting.texture.desc": "Enable mirror painting in 2D space on the image or texture",
	"menu.mirror_painting.texture_center": "Origin",
	"menu.mirror_painting.texture_frames": "Repeat on Flipbook Frames",
	"menu.mirror_painting.texture_frames.desc": "Mirror paint strokes to every frame of animated textures",
	
	"menu.mirror_modeling.mirror_uv": "Mirror UV",

	"menu.image_tiled_view.mirrored": "Mirrored Edges",

	"menu.image_onion_skin_view.frame": "Frames",
	"menu.image_onion_skin_view.frame.last_viewed": "Last Viewed Frame",
	"menu.image_onion_skin_view.frame.previous": "Previous Frame",
	"menu.image_onion_skin_view.frame.next": "Next Frame",
	"menu.image_onion_skin_view.frame.both": "Previous + Next",
	"menu.image_onion_skin_view.display": "Display",
	"menu.image_onion_skin_view.display.pixels": "Smaller Pixels",
	"menu.image_onion_skin_view.display.transparent": "Transparent",
	"menu.image_onion_skin_view.above": "Display Above",

	"menu.animation_onion_skin.frames": "Frames",
	"menu.animation_onion_skin.select": "Select",
	"menu.animation_onion_skin.previous": "Previous",
	"menu.animation_onion_skin.next": "Next",
	"menu.animation_onion_skin.previous_next": "Previous + Next",
	"menu.animation_onion_skin.count": "Count",
	"menu.animation_onion_skin.interval": "Interval",
	"menu.animation_onion_skin_selective": "Selective Onion Skin",
	"menu.animation_onion_skin_selective.desc": "Only display onion skin for the selected part of the model",

	"menu.toolbar.edit": "Customize Toolbar",
	"menu.toolbar.reset": "Reset Toolbar",
	"menu.toolbar.overflow": "Toolbar Overflow",

	"menu.animation.loop": "Loop Mode",
	"menu.animation.loop.once": "Play Once",
	"menu.animation.loop.hold": "Hold On Last Frame",
	"menu.animation.loop.loop": "Loop",
	"menu.animation.override": "Override",
	"menu.animation.anim_time_update": "Anim Time Update",
	"menu.animation.blend_weight": "Blend Weight",
	"menu.animation.start_delay": "Start Delay",
	"menu.animation.loop_delay": "Loop Delay",
	"menu.animation.save": "Save",
	"menu.animation.properties": "Properties...",
	"menu.animation.file": "File",
	"menu.animation.snapping": "Snapping",
	"menu.animation.open_location": "Show in File Explorer",
	"menu.animation.reload": "Reload",
	"menu.animation.unload": "Unload",
	"menu.animation.flip_keyframes": "Flip Keyframes",
	"menu.animation.playing": "Playing",

	"menu.animation_file.save_as": "Save As",
	"menu.animation_file.unload": "Unload File",
	"menu.animation_file.import_remaining": "Import Remaining from File",

	"menu.animator.rotation_global": "Rotate in Global Space",
	"menu.animator.quaternion_interpolation": "Quaternion Interpolation",

	"menu.keyframe.quaternion": "Quaternion",

	"menu.timeline_marker.set_time": "Set Time...",

	"menu.mobile_keyboard.disable_all": "Disable All",

	"menu.paste.face": "UV Face",
	"menu.paste.mesh_selection": "Mesh Selection",
	"menu.paste.outliner": "Elements",

	"edit.loop_cut.direction": "Direction",
	"edit.loop_cut.offset": "Offset",
	"edit.loop_cut.cuts": "Cuts",
	"edit.loop_cut.unit": "Unit",
	"edit.loop_cut.unit.size_units": "Size Units",
	"edit.loop_cut.unit.percent": "Percent",
	"edit.loop_cut.spacing": "Spacing",
	"edit.loop_cut.spacing.proportional": "Proportional",
	"edit.loop_cut.spacing.even_start": "Even - From Start",
	"edit.loop_cut.spacing.even_end": "Even - From End",
	"edit.extrude_mesh_selection.extend": "Extend",
	"edit.extrude_mesh_selection.direction": "Direction",
	"edit.extrude_mesh_selection.direction.outwards": "Outwards",
	"edit.extrude_mesh_selection.direction.average": "Average",
	"edit.extrude_mesh_selection.even_extend": "Even Extend",
	"edit.solidify_mesh_selection.thickness": "Thickness",
	"edit.vertex_snap.align": "Align",
	"edit.vertex_snap.align.longest": "Longest Axis",
	"edit.vertex_snap.align.direction": "Direction from Pivot",
	"edit.vertex_snap.align.align_axis": "%0 Axis",
	"edit.vertex_snap.ignore_axis": "Ignore Axis",
	"edit.extrude_spline_selection.extend": "Extend",
	"edit.divide_spline_curve.position": "Position",
	"edit.reparent_selection.adjust_position": "Preserve World Transform",

	"web.download_app": "Download App",

	"interface.streamer_mode_on": "Streamer Mode Enabled",

	"group.bedrock_binding": "Binding",
	"group.cem_attach": "CEM Attach",
	"group.cem_model": "CEM Model",
	"group.cem_scale": "CEM Scale",

	"cube.rescale": "Rotation Rescale",
	"cube.rescale.desc": "Rescale cube to compensate for the rotation angle",
	"cube.shade_direction_override": "Shade Direction Override",
	"cube.shade_direction_override.desc": "Shade every face of the cube as if it was facing this direction. If not set, each face is shaded based on the direction it actually faces. This does not affect ambient occlusion or shading based on light level.",
	"cube.color.light_blue": "Light Blue",
	"cube.color.yellow": "Yellow",
	"cube.color.orange": "Orange",
	"cube.color.red": "Red",
	"cube.color.purple": "Purple",
	"cube.color.blue": "Blue",
	"cube.color.green": "Green",
	"cube.color.lime": "Lime",
	"cube.color.pink": "Pink",
	"cube.color.silver": "Silver",

	"mesh.shading": "Shading",
	"mesh.shading.flat": "Flat",
	"mesh.shading.smooth": "Smooth",

	"spline_mesh.cyclic": "Cyclic",
	"spline_mesh.cyclic.desc": "Whether the selected spline should form a loop (Cycle)",

	"billboard.offset": "Offset",
	"billboard.facing_mode": "Facing Mode",
	"billboard.facing_mode.lookat": "Look At",
	"billboard.facing_mode.lookat_y": "Look At Y",
	"billboard.facing_mode.rotate": "Rotate",
	"billboard.facing_mode.rotate_y": "Rotate Y",

	"armature_bone.connected": "Connected",

	"null_object.ik_target": "IK Target",
	"null_object.ik_source": "IK Source",
	"null_object.ik_pole": "IK Pole",

	"texture_mesh.texture_name": "Texture Name",

	"switches.visibility": "Visibility",
	"switches.lock": "Lock",
	"switches.export": "Export",
	"switches.shade": "Shade",
	"switches.mirror": "Mirror UV",
	"switches.autouv": "Auto UV",
	"switches.autouv.alt": "Relative",

	"texture.error.file": "File not found",
	"texture.error.too_large": "Resolution exceeds the maximum of %0",
	"texture.error.parent": "Texture file provided by parent model",

	"reference_image.image": "Image",
	"reference_image.position": "Position",
	"reference_image.size": "Size",
	"reference_image.rotation": "Rotation",
	"reference_image.opacity": "Opacity",
	"reference_image.visibility": "Visibility",
	"reference_image.clear_mode": "Clear Mode",
	"reference_image.layer": "Layer",
	"reference_image.layer.background": "Behind Model",
	"reference_image.layer.viewport": "Above Model",
	"reference_image.layer.float": "Above Interface",
	"reference_image.layer.scene": "3D Scene",
	"reference_image.blueprint": "Locked Blueprint",
	"reference_image.view_mode": "View Mode",
	"reference_image.view_mode.flat_image": "Flat Image",
	"reference_image.view_mode.billboard": "3D Billboard",
	"reference_image.scope": "Scope",
	"reference_image.scope.project": "Just this project",
	"reference_image.scope.global": "All projects",
	"reference_image.enabled_modes": "Enabled in Modes",
	"reference_image.sync_to_timeline": "Sync To Timeline",
	"reference_image.cull_backface": "Hide Backside",
	"reference_image.toggle_playback": "Play/Pause",

	"codec.common.encoding": "Encoding",
	"codec.common.armature": "Export Groups as Armature",
	"codec.common.merge_armature_mesh": "Merge Armature Mesh",
	"codec.common.export_animations": "Export Animations",
	"codec.common.embed_textures": "Embed Textures",
	"codec.common.format": "Format",
	"codec.image.quality": "Quality",
	"codec.image.alpha_channel": "Alpha Channel",
	"codec.image.animation_fps": "Animation FPS",

	"preview.center_camera": "Center Camera",

	"panel.uv": "UV",
	"panel.display": "Display",
	"panel.textures": "Textures",
	"panel.textures.images": "Images",
	"panel.layers": "Layers",
	"panel.color": "Color",
	"panel.palette": "Palette",
	"panel.color.picker_options": "Color Picker Options",
	"panel.outliner": "Outliner",
	"panel.collections": "Collections",
	"panel.chat": "Chat",
	"panel.animations": "Animations",
	"panel.animation_controllers": "Animation Controller",
	"panel.timeline": "Timeline",
	"panel.keyframe": "Keyframe",
	"panel.keyframe.type": "Keyframe (%0)",
	"panel.keyframe.toggle_uniform_scale": "Toggle Uniform Scale",
	"panel.keyframe.add_data_point": "Add Keyframe Data Point",
	"panel.keyframe.remove_data_point": "Remove Data Point",
	"panel.keyframe.pre": "Pre",
	"panel.keyframe.post": "Post",
	"panel.keyframe.change_effect_file": "Change Effect File",
	"panel.variable_placeholders": "Variable Placeholders",
	"panel.skin_pose": "Pose",
	"panel.skin_pose.none": "None",
	"panel.skin_pose.natural": "Natural",
	"panel.skin_pose.walking": "Walking",
	"panel.skin_pose.crouching": "Crouching",
	"panel.skin_pose.sitting": "Sitting",
	"panel.skin_pose.jumping": "Jumping",
	"panel.skin_pose.aiming": "Aiming",

	"panel.element": "Element",
	"panel.transform": "Transform",
	"panel.element.position": "Position",
	"panel.element.size": "Size",
	"panel.element.stretch": "Stretch",
	"panel.element.origin": "Pivot Point",
	"panel.element.rotation": "Rotation",
	"panel.element.spline_dimensions": "Spline Dimensions",

	"panel.bone": "Bone",
	"panel.bone.ik": "Inverse Kinematics (Experimental)",

	"uv_editor.title": "UV Editor",
	"uv_editor.face_properties": "Face Properties",
	"uv_editor.face_properties.material_instance": "Material Instance",
	"uv_editor.tint.info": "Tint can be enabled on a face to tell Minecraft to tint it. In vanilla, tint can only be used by specific blocks such as leaves and redstone dust, and can only have a value of 0.",
	"uv_editor.cullface.info": "Enabling cullface tells a face on a block to unrender if another full block is placed next to it in the specified direction in your Minecraft world. This can be used to optimize performance.",
	"uv_editor.material_instance.info": "Material instances can be set to a user-defined name. That name can be used in the block JSON file in the behavior pack to assign a particular texture and material that the face.",
	"uv_editor.show_all_faces": "Show All Faces",
	"uv_editor.show_selected_faces": "Show Selected Faces",
	"uv_editor.all_faces": "All",
	"uv_editor.no_faces": "None",
	"uv_editor.rotated": "Rotated",
	"uv_editor.rotate_uv": "Rotate UV",
	"uv_editor.scale_uv": "Scale UV",
	"uv_editor.auto_cull": "Cullface To Self",
	"uv_editor.copied": "Copied Face",
	"uv_editor.pasted": "Pasted Face",
	"uv_editor.copied_x": "Copied %0 Faces",
	"uv_editor.reset": "Reset Face",
	"uv_editor.maximized": "Maximized",
	"uv_editor.turned": "Turned Mapping",
	"uv_editor.autouv": "Auto Size",
	"uv_editor.mirrored": "Mirrored",
	"uv_editor.to_all": "Applied To All Faces",
	"uv_editor.transparent": "Made Transparent",
	"uv_editor.cullface_on": "Cullface On",
	"uv_editor.cullface_off": "Cullface Off",
	"uv_editor.tint_on": "Tint On",
	"uv_editor.tint_off": "Tint Off",
	"uv_editor.copy_selection": "Copy Selection",
	"uv_editor.paste_selection": "Paste Selection",
	"uv_editor.transparent_face": "Transparent Face",

	"uv_editor.copy_paste_tool.place": "Place",
	"uv_editor.copy_paste_tool.to_layer": "To New Layer",
	"uv_editor.copy_paste_tool.mirror_x": "Mirror X",
	"uv_editor.copy_paste_tool.mirror_y": "Mirror Y",
	"uv_editor.copy_paste_tool.rotate": "Rotate 90 Degrees",

	"face.north": "North",
	"face.south": "South",
	"face.west": "West",
	"face.east": "East",
	"face.up": "Up",
	"face.down": "Down",

	"direction.north": "North",
	"direction.south": "South",
	"direction.west": "West",
	"direction.east": "East",
	"direction.top": "Top",
	"direction.bottom": "Bottom",

	"camera_angle.common_isometric_right": "Isometric Right (2:1)",
	"camera_angle.common_isometric_left": "Isometric Left (2:1)",
	"camera_angle.true_isometric_right": "True Isometric Right (30°)",
	"camera_angle.true_isometric_left": "True Isometric Left (30°)",

	"dialog.edit_session.title": "Edit Session",
	"edit_session.username": "Username",
	"edit_session.token": "Token",
	"edit_session.about": "Edit Sessions can be used to collaborate on models across the internet. Create a session, copy the token, and send it to friends, who can then use it to join.",
	"edit_session.join": "Join Session",
	"edit_session.create": "Create Session",
	"edit_session.quit": "Quit Session",
	"edit_session.joined": "%0 joined the session",
	"edit_session.left": "%0 left the session",
	"edit_session.welcome": "Welcome to this session by %0",
	"edit_session.quit_session": "Left current session",
	"edit_session.status": "Status",
	"edit_session.hosting": "Hosting",
	"edit_session.connected": "Connected to a session",

	"display.slot.third_right": "Thirdperson Right",
	"display.slot.third_left": "Thirdperson Left",
	"display.slot.first_right": "Firstperson Right",
	"display.slot.first_left": "Firstperson Left",
	"display.slot.head": "Head",
	"display.slot.ground": "Ground",
	"display.slot.frame": "Frame",
	"display.slot.embedded": "Embedded",
	"display.slot.on_shelf": "Shelf",
	"display.slot.gui": "GUI",

	"display.rotation": "Rotation",
	"display.translation": "Translation",
	"display.scale": "Scale",
	"display.mirror": "Mirror",
	"display.rotation_pivot": "Rotation Pivot",
	"display.scale_pivot": "Scale Pivot",
	"display.slot": "Slot",
	"display.reference": "Reference Model",
	"display.pose_angle": "Pose Angle (For Preview Only)",
	"display.animate_preview": "Preview Animation",

	"display.reference.player": "Player",
	"display.reference.zombie": "Zombie",
	"display.reference.armor_stand": "Armor Stand",
	"display.reference.baby_zombie": "Baby Zombie",
	"display.reference.armor_stand_small": "Armor Stand Small",
	"display.reference.fox": "Fox",
	"display.reference.monitor": "Normal",
	"display.reference.bow": "Charged Bow",
	"display.reference.crossbow": "Charged Crossbow",
	"display.reference.eating": "Eating",
	"display.reference.tooting": "Horn Tooting",
	"display.reference.block": "Block",
	"display.reference.flower_pot": "Flower Pot",
	"display.reference.frame": "Item Frame",
	"display.reference.frame_invisible": "Item Frame (Invisible)",
	"display.reference.frame_top": "Item Frame Top",
	"display.reference.frame_top_invisible": "Item Frame Top (Invisible)",
	"display.reference.shelf": "Shelf (All Slots)",
	"display.reference.shelf_left": "Shelf (Left Slot)",
	"display.reference.shelf_center": "Shelf (Center Slot)",
	"display.reference.shelf_right": "Shelf (Right Slot)",
	"display.reference.inventory_nine": "3x3",
	"display.reference.inventory_full": "Inventory",
	"display.reference.hud": "HUD",

	"display.preset.blank_name": "Please enter a name",
	"display.preset.item": "Default Item",
	"display.preset.block": "Default Block",
	"display.preset.handheld": "Default Weapon",
	"display.preset.rod": "Default Rod",
	"display.preset.armor_stand": "Ground (Armor Stand)",

	"preview_scene.studio": "Studio",
	"preview_scene.sky": "Sky",
	"preview_scene.space": "Space",
	"preview_scene.minecraft_overworld": "Overworld",
	"preview_scene.minecraft_nether": "Nether",
	"preview_scene.minecraft_end": "End",
	"preview_scene.minecraft_plains": "Plains",
	"preview_scene.minecraft_cherry_grove": "Cherry Grove",
	"preview_scene.minecraft_snowy_tundra": "Snowy Tundra",
	"preview_scene.minecraft_sunset": "Sunset",
	"preview_scene.minecraft_night": "Night",
	"preview_scene.minecraft_desert": "Desert",
	"preview_scene.minecraft_underwater": "Underwater",
	"preview_scene.minecraft_ocean": "Ocean",
	"preview_scene.minecraft_coral_reef": "Coral Reef",
	"preview_scene.minecraft_lush_cave": "Lush Cave",
	"preview_scene.minecraft_deep_dark": "Deep Dark",

	"preview_model.transform": "Transform",
	"preview_model.reset_transform": "Reset Transform",
	"preview_model.minecraft_player": "Minecraft Player"
}